import React, { useEffect, useState, Fragment, useRef } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { insh, sto, premiA } from "../../../../Context/InshData";
import { getLS } from "../../../../utils/useLS";
import { inshF } from "../../../../Context/InshFront";
import moment from "moment";
import PropTypes from "prop-types";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";

import { useHistory, useLocation } from "react-router-dom";
import HomeBcode from "../../../../barcode/HomeBcode";
import dataF from "../../../../Server/dataF.json";
// f d
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
// f e
import {
    createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import clsx from "clsx";
import Container from "@material-ui/core/Container";

import {
    useStylesAuto,
    useStylesBA,
    useStylesFU,
    useStylesCAB,
    SaleCheckbox,
    useStylesSN,
} from "../../../../St/comps/UseStyle";

import { stElemnt } from "../../../../St/comps/cStyle";
import "../../../../St/comps/csStyle.css";
import ReConnect from "../../../../Start/ReConnect";
import { getInveTypeIndex } from "../../../../modules/utils";
import { getDefaultOmla } from "../../../../services/omlat-services";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import {
    PrintInvoiceDirectly,
} from "../components/printSerivce";
import PaidWindowForm from "../components/paidwidow/paidwindowform";
import { useLocalStorage } from "react-use";
import { wait } from "@testing-library/react";
import { colors, Paper, Typography } from "@material-ui/core";
import InvoiceOilHead from "./InvoiceOilHead";
import InvoiceOilItems from "./InvoiceOilItems";
import { useStylesUiElemment } from "../../../../St/Reports/UseStyle";
import i18next from "i18next";
import InvoiceOilPay from "./InvoiceOilPay";
import InvoiceOilAppBar from "./InvoiceOilAppBar";
import SearchInvoicesMains from "../models/search-model/SearchInvMains";
import PumpsCardList from "./PumpsCardList";
import OilItemsList from "./OilItemsList";
import InvoiceTypePrintA4 from "../models/InvoiceTypePrintA4";
import { handleInputSearchCustomers, viewHandleCustomers, viewItemsHandleInv } from "../components/SearchItemsFunction";
import CustomerDialogData from "../../../Customers/customers/CustomerDialogData";
import CustomersDialog from "../../../Customers/customers/customersDialog";
import { selectDateOrTime } from "../../../../services/saleAnalysis-services";
import { defualtValueSearch } from "../models/search-model/SearchInvoiceScreean";

//=====================================================================
let nevEve = "always",
    nl = null;
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

let LetvalueCurrUnits = null;

export default function InvoiceOilMain(props) {
    const { AutoOptions, isPurches, isStock, isMake, isDialog } = props;
    const cl = (c) => {
        console.log(c);
    };
    const hasRun = useRef("paper");

    const [showSc, setShowSc] = useState(true);
    const classes = useStyles();
    const clasBA = useStylesBA();
    const clasFu = useStylesFU();
    const clasCAB = useStylesCAB();
    const clasSN = useStylesSN();
    const clasAo = useStylesAuto();

    const [gets, setGets] = useState(insh.tbname);
    const [maxShifts, setMaxShifts] = useState(AutoOptions.maxShift.id);
    const [currentUserName, setCurrentUserName] = useState(AutoOptions.maxShift.name);
    const [invsSearchTable, setInvsSearchTable] = useState([]);
    const [value, setValue] = useState(0);
    const countCustomers = AutoOptions?.Customers?.length === 250 ? true : false;
    const [searchCustText, setSearchCustText] = useState("");

    const [idata, setIData] = useState(() => {
        return { ...insh.IdataInvs, date: moment(new Date()).format("YYYY-MM-DD") };
    }); //is data in ta
    //is data in ta
    const [allow, setAllow] = useState({ c: false, s: false, it: false, cud: false, main: true, items: false, pay: false });
    /* Anemation */
    const [transition, setTransition] = React.useState(undefined);
    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }
    function TransitionRight(props) {
        return <Slide {...props} direction="right" />;
    }
    function TransitionDown(props) {
        return <Slide {...props} direction="down" />;
    }

    const [isOpenSy, setIsOpenSy] = useState(false);

    const filter = createFilterOptions();

    //rsa
    const [isOpenCustomer, setIsOpenCustomer] = useState(false);
    const selectOilType = [
        { id: 1, name: "false", label: "حسب السعر" },
        { id: 2, name: "true", label: "حسب اللترات" },
        { id: 3, name: "true", label: "العداد" },
    ];
    const selectOilTypePay = [
        { id: 1, name: "cash", label: "cash" },
        { id: 2, name: "network", label: "network" },
        { id: -1, name: "agel", label: "أجل" },

    ];
    const optionsOilType = {
        select: selectOilType[0],
        pay: selectOilTypePay[0]
    };
    const [fromQountity, setfromQountity] = useState(optionsOilType);

    const [isOpenCustomerData, setIsOpenCustomerData] = useState(false);

    const [isOpenItems, setIsOpenItems] = useState(false);
    const [isOpenPay, setIsOpenPay] = useState(false);
    const [isOpenMain, setIsOpenMain] = useState(AutoOptions?.permType?.id === 5 ? true : false);
    const [isOpenPumps, setIsOpenPumps] = useState(AutoOptions?.permType?.id === 5 ? false : true);
    const [openPrint, setOpenPrint] = useState({ open: false, localInv: {}, invType: 1, invKind: 1 });
    const [foundData, setFoundData] = useState({found:{},omlat:[],invSet:{}}); //is data in ta


    const handleOpenCustomerData = () => {
        setAllow({ ...allow, cud: !isOpenCustomerData });
        setIsOpenCustomerData(!isOpenCustomerData);
    }; // E rsa
    const handleOpenCustomer = () => {
        setAllow({ ...allow, c: !isOpenCustomer });
        setIsOpenCustomer(!isOpenCustomer);
    }; // E rsa


    const handleOpenPayScreen = () => {
        setAllow({ ...allow, pay: !isOpenPay });
        setIsOpenItems(!isOpenPay);
    }; // E rsa
    // s Dup
    const backHome = () => {
        his.push({ pathname: "/" });
        window.location.reload(false);
    };

    // s DDown
    const [openDw, setOpenDw] = useState(false);

    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        setOpenDw(true);
    };
    const handCloseDw = () => {
        setOpenDw(false);
    };

    const [subInfo, setSubInfo] = useState(insh.InfoSub);

    const [counts, setCounts] = useState({ curr: 0 });
    const [showPaid, setShowPaid] = useLocalStorage("show-paid-window", false);
    /* s DcuD  */
    const [openCuD, setOpenCuD] = React.useState(false);

    const [dialog, setDialog] = React.useState(inshF.dia);
    useEffect(() => {
        window.onbeforeunload = function (e) {
            e.preventDefault();
            return "you can not refresh the page";
        };
    }, []);


    const handleClDia = (prop, state) => setDialog({ ...dialog, [prop]: state });
    const [openDwt, setOpenDwt] = useState(false);

    const handOpenDwt = (Transition) => {
        setTransition(() => Transition);
        getInvst(
            sto.User_typei
        );
        setOpenDwt(true);
    };
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const getInvst = async (utype) => {
        let today = moment(new Date()).format("YYYY-MM-DD");
        console.log("the data is", today)
        await axios
            .get(
                uri +
                "InvDatet" +
                `?id=${sto.empi}&&dateF=${today}&&dateT=${today}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&bran=${sto.branchi}`
            )
            .then((res) => {
                cl("===res.data");
                cl(res.data);
                setInvsShowt(res.data);
                setInvsShowFltr(res.data);
            })
            .catch((error) => { });
    };
    /* s DcuD and McuD */
    const handCOpenCu = (Transition) => {
        setBarcodes("");
        setTransition(() => Transition);
        setOpenCuD(true);
    };

    /* s PMD */
    const [openPMD, setOpenPMD] = useState(false);
    let typePress = "save";
    let openPay = false;


    const handleClickOpenPMD = (Transition) => {
        setTransition(() => Transition);
        setOpenPMD(true);
    };
    const handleClickOpenPaid = (type) => {
        typePress = type;
        // setValueBankPMD

        setOpenPMD(true);
    };
    const handClosePMD = async (state) => {
        if (state === "cancle") await restPM(state);
        await setOpenPMD(false);
    };
    /* e PMD */

    /* s BCSD */

    const [barcodes, setBarcodes] = useState("");
    const { t: transForm } = useTranslation(["forms"]);
    const _onDetected = async (result) => {
        const res = [];
        const item = currencies[barcodes_eds.indexOf(result)];
        res.push(item.units);

        if (res.length > 0) {
            await BefBarcodedataCurrencie(item.id, item.units);
            setIsBarcode(true);
        }
    };
    /* e BCSD */

    const [lbl, setLbl] = React.useState(insh.Lbl);
    const [switchState, setSwitchState] = React.useState(insh.SwitchState);
    const changSwitch = async (x) => {
        const kind = x.id;
        await changPaySwitch(kind, false);
        setfromQountity({ ...fromQountity, pay: x });
    };

    const changPaySwitch = async (kind, isDate) => {
        if (kind == -1) {
            setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
            setValueStock(AutoOptions.Stocks[0]);
            const reet = reInshAuto(0, "");
            setValueBank(reet);
            if (isDate) {
                setIData({
                    ...location.state.idata, inv_type: 1, pay_type: -1, bank: 0, cust_id: AutoOptions.Customers[0].id,
                    customer_name: AutoOptions.Customers[0].name,
                    date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
                });
            } else {
                setIData({
                    ...idata, pay_type: -1, bank: -1, inv_type: 1
                    , agel_part: idata.netAmount, Remaining: 0,
                    cash_part: 0, network_part: 0
                });
                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });
            }
            setValueType(AutoOptions.types[0]);
        }
        else if (kind == 2) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setValueStock(AutoOptions.Stocks[0]);
            setUiElement({ ...uiElement, bank: false });
            setValueType(AutoOptions.types[1]);
            if (isDate) {
                setIData({
                    ...location.state.idata, inv_type: 2, pay_type: 2, bank: AutoOptions.Banks[0].id,
                    cust_id: AutoOptions.Customers[0].id,
                    customer_name: AutoOptions.Customers[0].name,
                    date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
                });
            } else {
                setIData({
                    ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id, inv_type: 2,
                    network_part: idata.netAmount, agel_part: 0, cash_part: 0, bank_part: 0, Remaining: 0,
                    Pay_mouny: idata.netAmount,
                });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });
                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
            }
        }
        else {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true, stock: false });
            setValueStock(AutoOptions.Stocks[0]);
            if (isDate) {
                setIData({
                    ...location.state.idata, inv_type: 2, pay_type: 1, stock: AutoOptions.Stocks[0].id,
                    cust_id: AutoOptions.Customers[0].id, bank: 0,
                    customer_name: AutoOptions.Customers[0].name,
                    date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
                });
            } else {
                setIData({
                    ...idata, pay_type: 1, bank: 0, inv_type: 2, stock: AutoOptions.Stocks[0].id, cash_part: idata.netAmount,
                    network_part: 0, bank_part: 0, agel_part: 0, Remaining: 0, Pay_mouny: idata.netAmount,
                });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });
                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
            }
            setValueType(AutoOptions.types[1]);
        }
    };
    const reLoadCust = async (newCustData) => {
        if (newCustData != null) {
            let newCust = {
                id: newCustData.id,
                name: newCustData.name,
                Cust_inv_type: newCustData.Cust_inv_type,
                acc_no: newCustData.acc_no,
                salesmen: newCustData.salesmen,
                CustandSup: newCustData.CustandSup,
                maxdepit: newCustData.maxdepit,
            };
            setOptionsCustomers([newCust, ...optionsCustomers]);
            setValueCustomers(newCust);
            changAutoCustomers(newCust);
        }
    };
    const reUpdateCust = (updateData) => {
        if (updateData != null) {
            var otherOptions = optionsCustomers.filter((obj) => obj.id != updateData.id);
            let newCust = {
                id: updateData.id, name: updateData.name,
                Cust_inv_type: updateData.Cust_inv_type,
                acc_no: updateData.acc_no,
                salesmen: updateData.salesmen,
                CustandSup: updateData.CustandSup,
                maxdepit: updateData.maxdepit,
            };
            setOptionsCustomers([newCust, ...otherOptions]);
            setValueCustomers(newCust);
            changAutoCustomers(newCust);
        }
    };

    const handleCloseCuDWithSWState = () => {
        switchState.stayInDCurr ? setOpenCuD(true) : setOpenCuD(false);
        setSubInfo(insh.InfoSub);
    };

    const changChckedPM = (network, agel, bank, emp, onlyCheked) => {
        onlyCheked === ""
            ? setChecked({
                ...checked,
                network_partck: network,
                agel_partck: agel,
                bank_partck: bank,
                emp_partck: emp,
            })
            : setUiElement({ ...uiElement, [onlyCheked]: false });
    };

    const changAutosPM = (bank, bank2, emp, onlyCheked) => {
        if (onlyCheked === "") {
            if (bank === false) setValueBankPMD(insh.AutoBank);
            if (bank2 === false) setValueBankTransPMD(insh.AutoBank);
            if (emp === false) setValueEmployePMD(insh.Auto);
            setUiElement({
                ...uiElement,
                bankPM: !bank,
                bankPM2: !bank2,
                empPM: !bank,
            });
        } else {
            if (onlyCheked === "bankPM") setValueBankPMD(insh.AutoBank);
            else if (onlyCheked === "bankPM2") setValueBankTransPMD(insh.AutoBank);
            else if (onlyCheked === "empPM") setValueEmployePMD(insh.Auto);
            setUiElement({ ...uiElement, [onlyCheked]: true });
        }
    };

    const restPM = (from) => {
        let ck = { network: true, agel: true, bank: true, emp: true };
        if (from === "rest") {
            if (idata.network_part === "") ck.network = false;
            if (idata.agel_part === "") ck.agel = false;
            if (idata.bank_part === "") ck.bank = false;
            if (idata.emp_part === "") ck.emp = false;
        } else {
            ck.network = false;
            ck.agel = false;
            ck.bank = false;
            ck.emp = false;
        }
        changChckedPM(ck.network, ck.agel, ck.bank, ck.emp, "");
        changAutosPM(ck.network, ck.bank, ck.emp, "");
    };
    const [or, setOr] = useState(insh.Or);
    const [ished, setIshed] = useState(insh.ished);
    const [permiCuCo, setPrmiCuCo] = useState({});

    const getPrmetions = (resDataElm, permiCuCo) => {
        getAutoPricePays(permiCuCo.TSP);
        if (permistionInv.USP) {
            nevEve = "never";
        }

        setPrmiCuCo(permiCuCo);
    };

    const [uiElement, setUiElement] = useState({});
    const [permistionInv, setPermistionInv] = useState(AutoOptions.permsInvs);


    // >>>>> datas
    const [currencies, setCurrencies] = useState([]);
    const [invsShow, setInvsShow] = useState([]);
    const [invsShowt, setInvsShowt] = useState([]);
    const [exsub, setExSub] = useState(0);
    const [invsShowFltr, setInvsShowFltr] = useState([]);

    const [infoInv, setInfoInv] = useState({ id: "", InvId_Return: "" });

    const [isdata, setIsData] = useState([]); //is data in ta

    const location = useLocation();

    const [stor, setStor] = useState({}); //is data in ta
    const [storS, setStorS] = useState({}); //is data in ta

    const [groups, setGroups] = useState([]);
    const [valueType, setValueType] = useState(insh.Auto);

    //TypeInvs
    const [valueTypeFltr, setValueTypeFltr] = useState(insh.Auto);
    //Safes
    const [valueSafes, setValueSafes] = useState(AutoOptions.Safes[0]);
    //Customers
    const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions.Customers);

    const [valueCustomers, setValueCustomers] = useState(AutoOptions.Customers[0]);
    //Salesmen
    const [valueSalesmen, setValueSalesmen] = useState(AutoOptions?.salesuser);
    //Employee
    const [valueEmployePMD, setValueEmployePMD] = useState(insh.Auto);
    //Costcenter
    const [valueCostcenter, setValueCostcenter] = useState(AutoOptions?.centerUser);
    //Stock
    const [valueStock, setValueStock] = useState(AutoOptions.Stocks[0]);
    const [omlaValue, setOmlaValue] = useState(insh.Auto);
    // network
    const [valueBank, setValueBank] = useState(insh.AutoBank);
    // network PMD
    const [valueBankPMD, setValueBankPMD] = useState(insh.AutoBank);
    const [valueBanksPaid, setValueBanksPaid] = useState(insh.AutoBank);
    //Bank Trans PMD
    const [valueBankTransPMD, setValueBankTransPMD] = useState(insh.AutoBank);
    //Units

    const [countCurrBySafe, setCountCurrBySafe] = useState([]);
    const [currenciesToInv, setCurrenciesToInv] = useState([]);
    const [currUnit, setCurrUnit] = useState([]);
    const [currUnitsAll, setCurrUnitsAll] = useState([]);
    // const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
    const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
    const [optionsCurrUnitsTable, setOptionsCurrUnitsTable] = useState(insh.AutoOp);

    const clasui = useStylesUiElemment();


    const [valueCurrUnits, setValueCurrUnits] = useState(insh.Auto);
    const [valueItemUnits, setValueItemsUnits] = useState(insh.AutoUits);

    const [indexUnit, setIndexUnit] = useState(0);
    //PricePay
    const [optionsPricePay, setOptionsPricePay] = useState(insh.AutoOp);
    const [valuePricePay, setValuePricePay] = useState(insh.Auto);
    const [valuePumps, setValuePumps] = useState({});
    const [optionsItems, setOptionsItems] = useState(AutoOptions?.Items);


    // edrees changes
    const [itemId, setItemId] = useState("1");
    const [itemName, setItemName] = useState("1");

    const [barcodes_eds, setBarcodes_eds] = useState();

    const handleFocus = (e) => e.target.select();
    const getAutoPricePays = (i) => {
        setOptionsPricePay(insh.optionPricePay);
        setValuePricePay(insh.optionPricePay[i]);
    };

    const addChangds = () => {

        idata.date =
            moment(idata.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");
        idata.InvId_Return = infoInv.InvId_Return;

        if (idata.cust_id == null || idata.cust_id === "") {
            idata.cust_id = valueCustomers.id;
            idata.customer_name = valueCustomers.name;
        }
    };



    const fltringCurrencieToinv = async (res, pricePayId, changtaxperc) => {
        console.log("the response data is", res);
        if (setting.PrTy_InPr == "22") res.tax = 0;
        let sORp = 0;
        if (setting.cusType == 1) sORp = res.sale;
        else if (setting.cusType == 2) sORp = res.purch;
        if (changtaxperc == false) {
            res.tax = subInfo.taxperc;
            res.val1 = subInfo.val1;
        }
        if (pricePayId == 2) sORp = res.dPrice;
        else if (pricePayId == 3) sORp = res.jPrice;

        if (checked.autoOrStaticck === false) {
            setSubInfo({
                ...subInfo,
                hdshw: true,
                val1: res.val1,
                is_tab3_curr: res?.is_tab3_curr,
                id: res.id,
                minPrice: res.mPrice,
                Price: sORp,
        /*PricePu:res.purch,*/ barcode: res.barcode,
                symbol: res.symbol,
                type: res.type,
                perc: res.perc,
                taxperc: res.tax,
                totJust: (sORp * res.val1).toFixed(2),
                discount: "",
                DiscPers: "",
                taxval: ((sORp * res.tax) / 100).toFixed(2),
            });
        } else {
            subInfo.hdshw = true;
            subInfo.val1 = res.val1;
            subInfo.id = res.id;
            subInfo.Price = sORp;
            subInfo.minPrice = res.mPrice;
            subInfo.barcode = res.barcode;
            subInfo.symbol = res.symbol;
            subInfo.perc = res.perc;
            subInfo.taxperc = res.tax;
            subInfo.totJust = (sORp * res.val1).toFixed(2);
            subInfo.discount = "";
            subInfo.DiscPers = "";
            subInfo.type = res.type;
            subInfo.taxval = ((sORp * res.tax) / 100).toFixed(2);
            subInfo.is_tab3_curr = res.is_tab3_curr;
        }
    };

    const reLoadLastInv = async () => {
        const tb = {
            other: true,
            parms: {
                sProcTypeInvProc: setting.PrTy_InPr,
                branch: sto.branchi,
                tname: "invs",
            },
            autos: {},
        };
        await axios
            .post(uri + "Res", tb)
            .then((res) => {
                setInfoInv({ id: res.data.other.lastid, InvId_Return: "" });
            })
            .catch((error) => { });
    };

    const loadSto = async (cusType) => {
        const locSto = getLS("sto", {});
        setGets(locSto);
        // console.log("the log sto is", locSto);
        // setBarcodes_eds(AutoOptions.Items.map((c) => c.barcode));
        loadIdata(AutoOptions.Customers[0], AutoOptions.types, AutoOptions?.Banks);

        // const safe = getSafeDefault(locSto.permisApp.user_id, locSto.Users);
        setPermistionInv(AutoOptions.permsInvs);

        setValueSafes(AutoOptions.Safes[0]);
        setValueStock(AutoOptions.Stocks[0]);
        const defOmla = getDefaultOmla(locSto.omlats);
        setOmlaValue(defOmla);
        setOptionsCustomers(AutoOptions.Customers);

        setValueCustomers(AutoOptions.Customers[0]);
        if(cuRows.length===0){
            viewItemsHandleInv(-1, false, null, rptParams, setFetching, null, setcuRows);
        }
      
        setGroups(AutoOptions.groups);
        setValueTypeFltr(locSto.typesFltr[0]);
        getCustInvType(AutoOptions.Customers[0]);
    };

    const loadGet = async (branch, pTpI, empid, formid, invType) => {
        setInfoInv({ ...infoInv, id: AutoOptions.other?.lastid });
        getPrmetions(AutoOptions.permisElm, AutoOptions.permiCuCo);
        setShowSc(AutoOptions.wait?.state);
    };

    const [setting, setSetting] = useState({});
    const [style, setStyle] = useState({});
    const loadInsh = async () => {
        setSetting(location.state.setting);
        setStor(location.state.stor);
        loadGet(
            location.state.idata.branch,
            location.state.setting.PrTy_InPr,
            location.state.idata.create_user,
            location.state.setting.iformid,
            location.state.stor.invsType
        );
        loadSto(location.state.setting.cusType);
        setStorS(location.state.setting.stors);
        setStyle(location.state.style);
    };


    let setupReload = function () {
        // for update date in midnight
        const timeUntilMidnight = moment()
            .endOf("day")
            .add(10, "ms")
            .diff(moment(), "ms");
        return setTimeout(function () {
            setIData({ ...idata, trans_no: AutoOptions.maxShift?.id, date: moment(new Date()).format("YYYY-MM-DD") });

            setupReload();
        }, timeUntilMidnight);
    };

    /* =============================== */
    useEffect(() => {
        loadInsh();
        setupReload();
    }, []);

    /* =============================== */

    const toDoIdata = (prop, value) => {
        setIData({ ...idata, [prop]: value });
    };
    const onChangeData = (propName) => (event) => {
        setIData({ ...idata, [propName]: event.target.value });
    };
    const reInshAuto = (id, name) => {
        if (id == null && name == "") return insh.Auto;
        else return { id: id, name: name };
    };

    const loadIdata = (valCust, locStoTypes, Banks) => {
        let locR = getLS("DataRem", {});
        const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

        setIData({
            ...location.state.idata,
            branch: locR.branchi,
            sales_emp: locR.empi,
            create_user: locR.idi,
            customer_name: valCust.name,
            cust_id: valCust.id,
            inv_type: AutoOptions.types[0].id,
            trans_no: AutoOptions.maxShift.id,
            date: moment(new Date()).format("YYYY-MM-DD"),
        });
        // eds change
    };

    const getCustInvType = (valCust) => {
        setUiElement(insh.UiElement);

        let kind_inv = 2;
        let locR = getLS("DataRem", {});

        const locSto = getLS("sto", {});



        if (AutoOptions.Customers[0].Cust_inv_type != null) {
            if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);

                setPayment({ ...payment, paidup: 0, stay: 0 });

                setValueStock(AutoOptions.Stocks[0]);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });
                setIData({
                    ...location.state.idata,
                    inv_type: 2,
                    pay_type: 1,
                    bank: 0,
                    cust_id: valCust.id,
                    stock: AutoOptions.Stocks[0].id,
                    customer_name: valCust.name,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                //setOptionsBank(insh.AutoBankOp);
                setValueType(AutoOptions.types[1]);


            } else if (AutoOptions.Customers[0].Cust_inv_type === 1) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: true,
                    bank: true,
                });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...location.state.idata,
                    inv_type: 1, pay_type: -1, bank: -1,
                    cust_id: valCust.id,
                    customer_name: valCust.name,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                setValueType(AutoOptions.types[0]);

            }
            else if (AutoOptions.Customers[0].Cust_inv_type === 3 || AutoOptions.Customers[0].Cust_inv_type === 4) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: false,
                });
                setValueStock(AutoOptions.Stocks[0]);
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setPayment({ ...payment, paidup: 0, stay: 0 });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: 0 });
                setSwitchState({ ...switchState, cashORnetworksw: true });
                const text = transForm("network").toString();
                setLbl({ ...lbl, chashNetwork: text });


                setIData({
                    ...location.state.idata,
                    inv_type: 2,
                    pay_type: 2,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    bank: AutoOptions.Banks[0].id,
                    cust_id: AutoOptions.Customers[0].id,
                    customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
                });
                setValueType(AutoOptions.types[1]); //getAutobanks(0);
            }
        } else {
            setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({
                ...uiElement,
                stock: false,
                payMethod: false,
                bank: true,
            });
            setSwitchState({ ...switchState, cashORnetworksw: false });
            setIData({
                ...location.state.idata, inv_type: 2,
                branch: locR.branchi,
                stock: AutoOptions.Stocks[0].id,
                sales_emp: sto.empi,
                create_user: locR.idi,
                pay_type: 1, bank: 0, cust_id: valCust.id,
                customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
            });

            setValueType(AutoOptions.types[1]);

        }
    }
    const changAutoType = (newValue) => {
        console.log(newValue);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setValueType(newValue);

        let invT = newValue.id;
        if (newValue.id === 2) {
            if (switchState.cashORnetworksw === false) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
            }
            else if (switchState.cashORnetworksw == true) {
                setUiElement({ ...uiElement, bank: false });
                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });

                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: true });
                setLbl({ ...lbl, chashNetwork: transForm("network") });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setIData({
                    ...idata,
                    pay_type: 2,
                    bank: AutoOptions.Banks[0].id,
                    cust_id: valueCustomers.id, customer_name: valueCustomers.name,
                    inv_type: invT,
                });
            } else {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
            }
        }
        else if (newValue.id === 1) {
            setfromQountity({ ...fromQountity, pay: selectOilTypePay[2] });
            if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
                if (switchState.cashORnetworksw === false) {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: AutoOptions.Stocks[0].id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });
                }
                else if (switchState.cashORnetworksw === true) {
                    remains.cashPart = 0;
                    remains.agelPart = payment.stay;
                    remains.networkPart = payment.paidup;
                    remains.bankPart = 0;
                    setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: valueBank.id,
                        cash_part: 0,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        inv_type: invT,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });

                } else {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: AutoOptions.Stocks[0].id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });
                }

            } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    Remaining: idata.netAmount,
                    Pay_mouny: 0,
                    agel_part: idata.netAmount,
                    inv_type: invT,
                });
            }
            else {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata, pay_type: -1, bank: -1, inv_type: invT
                    , agel_part: payment.stay, Remaining: payment.stay,
                    cash_part: payment.paidup
                });

            }
        }
        console.log(" the inv_type is", invT);
    };
    const searchTimeout = useRef(null);
    const handleInputSearchCust = (event, newValue, reason) => {
        handleInputSearchCustomers(newValue, AutoOptions.Customers, searchTimeout, setOptionsCustomers,
            countCustomers, setting.cusType, false, setSearchCustText, reason);
    };
    const changAutoCustomers = async (newValue) => {
        await changCustomers(newValue);
    };
    const changCustomers = (newValue) => {
        // console.log(newValue);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        let invT = null;
        setValueCustomers(newValue);
        newValue.Cust_inv_type == 1
            ? setValueType(AutoOptions.types[0])
            : setValueType(AutoOptions.types[1]);
        newValue.Cust_inv_type == 1
            ? (invT = AutoOptions.types[0].id)
            : (invT = AutoOptions.types[1].id);

        if (invT === 2) {

            if (newValue.Cust_inv_type != null) {
                if (newValue.Cust_inv_type == 0 || newValue.Cust_inv_type == 2 || newValue.Cust_inv_type == 5) {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.networkPart = 0;
                    remains.bankPart = 0;
                    setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                    setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });


                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });

                    setIData({
                        ...idata,
                        pay_type: 1,
                        bank: 0,
                        inv_type: invT,
                        customer_name: newValue.name,
                        cust_id: newValue.id,
                    });
                } else if (newValue.Cust_inv_type == 3 || newValue.Cust_inv_type == 4) {

                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                    setUiElement({ ...uiElement, bank: false });
                    setSwitchState({ ...switchState, cashORnetworksw: true });
                    setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });
                    setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                    setIData({
                        ...idata,
                        pay_type: 2,
                        bank: AutoOptions.Banks[0].id,
                        inv_type: invT,
                        customer_name: newValue.name,
                        cust_id: newValue.id,
                    });
                }
            }
            else {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({
                    ...idata,
                    pay_type: 1,
                    bank: 0,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                });
            }
        }
        else if (invT === 1) {

            if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {


                if (switchState.cashORnetworksw === false) {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: valueStock.id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }
                else if (switchState.cashORnetworksw === true) {
                    remains.cashPart = 0;
                    remains.agelPart = payment.stay;
                    remains.networkPart = payment.paidup;
                    remains.bankPart = 0;
                    setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: valueBank.id,
                        cash_part: 0,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }
                else {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: valueStock.id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }

            } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    Remaining: idata.netAmount,
                    Pay_mouny: 0,
                    agel_part: idata.netAmount,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                });
            }
            else {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                    agel_part: payment.stay,
                    Remaining: payment.stay,
                    cash_part: payment.paidup
                });
            }
        } else {
            setIData({
                ...idata,
                customer_name: newValue.name,
                cust_id: newValue.id,
            });
            idata.inv_type = invT;
            idata.customer_name = newValue.name;
            idata.cust_id = newValue.id;
        }
        setSearchCustText("");
        // console.log(" the inv_type is", invT);
    };
    const handleIconSearchCust = () => {
        if (countCustomers && searchCustText !== "" || searchCustText !== null) {
            viewHandleCustomers(searchCustText, setOptionsCustomers, false, setting.cusType, -1, AutoOptions.Customers);
        }
    };
    const changAutoStock = (newValue) => {
        setValueStock(newValue);
        toDoIdata("stock", newValue.id);
    };
    const changAutoSafes = (newValue) => {
        setValueSafes(newValue);
        toDoIdata("safe", newValue.id);
    };
    const changAutoBank = (newValue) => {
        setValueBank(newValue);
        toDoIdata("bank", newValue.id); /*setValueBankPMD(newValue);*/
    };
    const changAutoBank2 = (newValue) => {
        setValueBankTransPMD(newValue);
        toDoIdata("bank2", newValue.id);
    };
    const changPayment = (prop) => (event) => {
        if (prop === "paidup") {
            payment.stay = (event.target.value - parseFloat(idata.netAmount)).toFixed(2);
            payment.paidupPMDcn = event.target.value;
            payment.stayPMDcn = payment.stay;
            setPayment({ ...payment, [prop]: event.target.value });
        } else if (prop === "paidupPMDcn") {
            payment.stayPMDcn = (
                event.target.value - parseFloat(idata.netAmount)
            ).toFixed(2);
            setPayment({ ...payment, [prop]: event.target.value });
        }
    };
    const changClick = (prop, ev) => {
        if (prop == "minus") setUiElement({ ...uiElement, [prop]: ev, rate: true });
        else if (prop == "rate")
            setUiElement({ ...uiElement, [prop]: ev, minus: true });
    };
    const [cuRows, setcuRows] = useState([]);
    const [searchedInvShow, setSearchedInvShow] = useState("");
    const [checked, setChecked] = useState(insh.Checked);
    const fltringAutoCurrUnits = (chitem) => {
        setIndexUnit(0);
        const res = [];
        setCurrUnitsAll(chitem);
        if (checked.autoOrStaticck == false) {
            setOptionsCurrUnits(chitem);
            setValueCurrUnits(chitem[0]);
            LetvalueCurrUnits = chitem[0];
        } else LetvalueCurrUnits = chitem[0];
    };
    const BefBarcodedataCurrencie = async (id, ious) => {
        setItemId(id);
        setCurrUnit(ious);
        // permiCuCo.DTSP = false;
        await fltringAutoCurrUnits(ious);
        insh.stateChang.taxperc = true;
        await fltringCurrencieToinv(
            ious[0],
            valuePricePay.id,
            insh.stateChang.taxperc
        );
        // eds change
        await changeCountCurr(ious[0].barcode);
    };


    const onPumpsClicks = (pump) => {
        var newItems =cuRows.filter((obj) => obj.id == pump.item);
        var newsafe = AutoOptions.Safes.find((obj) => obj.id == pump.safe);
        if (newsafe.id != null) {
            setIData({
                ...idata,
                pump: pump?.id,
                safe: newsafe.id,
            });
        } else {
            setIData({
                ...idata,
                pump: pump?.id,
                safe: AutoOptions.Safes[0].id,
            });
        }
        setOptionsItems(newItems);

        setValuePumps(pump);

        setSubInfo({
            ...subInfo,
            count: pump.count
        });
        setIsOpenPumps(false);
        setIsOpenMain(true);

    };

    const onRowClicks = (dataCode) => {
        setSubInfo(insh.InfoSub);
        setItemId(dataCode.id);
        setItemName(dataCode.symbol);
        setIsOpenMain(false);
        setIsOpenItems(true);
        // console.log("the data is", dataCode)
        let pricei = 0.0;
        let totJust = 0.0;
        let taxval = 0.0;
        let taxperc = 0.0;
        let diaperc = 0.0;
        let dismount = 0.0;
        let valperc = 0.0;
        if (setting.PrTy_InPr === "22") {
            taxperc = 0.0;
            pricei = parseFloat(dataCode?.purch_price).toFixed(2);
        } else if (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "03") {
            // pricei = parseFloat(dataCode?.sale_price);
            pricei = permistionInv?.TYPEPRICE === 0 || permistionInv?.TYPEPRICE == null ? parseFloat(dataCode?.sale_price) :
                permistionInv?.TYPEPRICE === 1 ? parseFloat(dataCode?.Distributor_price) : parseFloat(dataCode?.jomla_price);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        }
        else {
            pricei = parseFloat(dataCode?.purch_price);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        };

        if (dataCode.discount == null) { dataCode.discount = 0; };
        if (dataCode.amount_disc == null) { dataCode.amount_disc = 0; };

        taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
        totJust = (parseFloat(pricei)).toFixed(2);
        diaperc = (parseFloat(0)).toFixed(2);
        dismount = (parseFloat(0)).toFixed(2);
        valperc = (parseFloat(1)).toFixed(2);

        setSubInfo({
            ...subInfo,
            val1: 0,
            is_tab3_curr: dataCode?.is_tab3_curr,
            id: dataCode.id,
            minPrice: dataCode.min_sale_price,
            Price: parseFloat(pricei).toFixed(2),
            val: 0,
            barcode: dataCode.barcode,
            symbol: dataCode.symbol,
            type: dataCode.type,
            perc: 1,
            taxperc: taxperc,
            totJust: parseFloat(pricei).toFixed(2),
            discount: 0,
            DiscPers: 0,
            taxval: ((dataCode?.sale_price * taxperc) / 100).toFixed(2),
            unitame: "لتر",
            jPrice: parseFloat(dataCode.jomla_price),
            dPrice: parseFloat(dataCode.Distributor_price),
            salePrice: parseFloat(dataCode.sale_price),
            PricePu: parseFloat(dataCode.purch_price),
            unit: dataCode?.unit ?? 1,
        });
        setCounts({ curr: 0 });
        // handleOpenMainScreen();
        setIsOpenPay(false);

        // handleOpenItemsScreen();
    };


    const changeCountCurr = (bc) => {
        try {
            const resCurr = [];
            countCurrBySafe.map((x) => {
                if (x?.barcode == bc && x.safe == valueSafes.id) resCurr.push(x);
            });
            if (checked.autoOrStaticck === false) {
                resCurr.length != 0
                    ? setCounts({ curr: resCurr[0].Qtys })
                    : setCounts({ curr: 0 });
            } else {
                resCurr.length != 0
                    ? (counts.curr = resCurr[0].Qtys)
                    : (counts.curr = 0);
            }
        } catch (error) {
            alert("هناك خطاء في الصنف قم برماجعة الدعم الفني");
        }
    };

    const changInfo = (prop) => (event) => {
        if (prop === "totJust1") {
            let valOils = parseFloat(event.target.value / subInfo.Price).toFixed(3);
            subInfo.val1 = valOils;
            subInfo.totJust = event.target.value;
            let totPrice = parseFloat(event.target.value).toFixed(3);
            subInfo.discount = (
                parseFloat(subInfo.Price * valOils) *
                (subInfo.DiscPers / 100)
            ).toFixed(4);
            subInfo.taxval = parseFloat(
                (totPrice * subInfo.taxperc) / 100
            ).toFixed(4);
        } else if (prop === "valOil") {
            let prce = parseFloat(event.target.value * subInfo.Price).toFixed(4);
            subInfo.totJust = prce;
            subInfo.val1 = event.target.value;
            let totVal1 = parseFloat(event.target.value ?? 0).toFixed(4);

            subInfo.discount = (
                parseFloat(totVal1 * subInfo.Price) *
                (subInfo.DiscPers / 100)
            ).toFixed(2);
            subInfo.taxval = parseFloat(
                (prce * subInfo.taxperc) / 100
            ).toFixed(2);
        } else if (prop === "newCount") {
            let old_Count = Number(valuePumps.count);
            let new_count = Number(event.target.value)
            let new_val = Number(new_count - old_Count);


            let prce = parseFloat(new_val * subInfo.Price).toFixed(4);
            subInfo.totJust = prce;
            subInfo.val1 = new_val;
            let totVal1 = parseFloat(new_val ?? 0).toFixed(4);

            subInfo.discount = (
                parseFloat(totVal1 * subInfo.Price) *
                (subInfo.DiscPers / 100)
            ).toFixed(2);
            subInfo.taxval = parseFloat(
                (prce * subInfo.taxperc) / 100
            ).toFixed(2);

            setSubInfo({
                ...subInfo, [prop]: event.target.value,
                oldCount: old_Count, val1: new_val, val: 1
            });
        } else if (prop === "totJust2") {
            let valOils = 1;
            subInfo.val1 = 1;
            subInfo.totJust = event.target.value;
            subInfo.Price = event.target.value;
            let totPrice = parseFloat(event.target.value).toFixed(3);
            subInfo.discount = (
                parseFloat(subInfo.Price * valOils) *
                (subInfo.DiscPers / 100)
            ).toFixed(4);
            subInfo.taxval = parseFloat(
                (totPrice * subInfo.taxperc) / 100
            ).toFixed(4);
        }

        setSubInfo({
            ...subInfo, [prop]: event.target.value
        });
    };


    const beZero = () => {
        setStor({ ...stor, comt: -1 });
        if (subInfo.discount === "") subInfo.discount = 0;
        if (subInfo.DiscPers === "") subInfo.DiscPers = 0;
        if (subInfo.Price === "") subInfo.Price = 0;
        if (subInfo.val1 === "") subInfo.val1 = 0;
        if (subInfo.perc === "") subInfo.perc = 0;
        if (subInfo.taxperc === "") subInfo.taxperc = 0;
        if (subInfo.taxval === "") subInfo.taxval = 0;
        if (subInfo.totJust === "") subInfo.totJust = 0;
    };

    const getrowDataCurrencie = async () => {
        beZero();
        or.cros = "newRow";
        or.PrAC = 0;
        if (parseFloat(subInfo?.val1) <= 0) {
            alert("لا يمكن حفظ الفاتورة بقيمة صفر");

        } else if (subInfo.barcode != "") {
            if (parseFloat(subInfo.val1) != 0) {
                let val1InSub = 0,
                    countsCurr = 0,
                    minCurrPrice = 0,
                    subInfoVal1_perc = subInfo.val1 * subInfo.perc;
                minCurrPrice = (parseFloat(subInfo.minPrice) * parseFloat(subInfo.perc)).toFixed(2);
                for (let m = 0; m < isdata.length; m++) {
                    if (subInfo.barcode == isdata[m].barcode)
                        val1InSub = isdata[m].val1;
                }
                countsCurr = parseInt(counts.curr) - parseInt(val1InSub);


                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") {

                    if (permistionInv.SNOP === true && subInfo != null && parseFloat(subInfo.Price) < parseFloat(subInfo.PricePu)) {
                        alert(
                            `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : ${subInfo.PricePu}`
                        );
                    } else if (permistionInv.SNOMIN === 1 && parseFloat(subInfo.Price) < parseFloat(minCurrPrice)) {
                        alert(
                            `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${minCurrPrice}`
                        );
                    } else if (permistionInv.ASPZ === false && subInfo.Price <= 0) {
                        alert(
                            `لا يوجد لديك صلاحية البيع بسعر صفر `
                        );
                    }
                    else if (permistionInv.SIM == false &&
                        countsCurr < subInfoVal1_perc &&
                        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                        alert(
                            `
          الكمية المدخلة للصنف أكبر من رصيد المخزن
          الكمية الاجمالية المدخلة : ${parseFloat(subInfo.val1) * parseFloat(subInfo.perc)
                            }
          رصيد المخزن : ${valueSafes.name} = ${parseInt(counts.curr) - parseInt(val1InSub)
                            }
          `
                        );
                    }
                    else if (permistionInv.APDC === 1 && permistionInv.DSOI == 1 && parseFloat(subInfo.DiscPers) > parseFloat(permistionInv.SDP)) {
                        alert(
                            `
          لقد تجاوزت نسبة الخصم المسموح بها
          نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                            }
          `
                        );
                    }
                    else if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 && parseFloat(subInfo.discount) > parseFloat(permistionInv.SDV)) {
                        alert(
                            `
          لقد تجاوزت مبلغ الخصم المسموح بها
          مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
                            }
          `
                        );
                    }
                    else if (permistionInv.APDC === 3 && permistionInv.DSOI == 1 &&
                        ((parseFloat(permistionInv.SDV) != 0 && subInfo.discount > permistionInv.SDV) ||
                            (parseFloat(permistionInv.SDP) != 0 && parseFloat(subInfo.DiscPers) > parseFloat(permistionInv.SDP)))) {
                        alert(
                            `
          لقد تجاوزت حد الخصم المسموح بها
            }
          `
                        );
                    }
                    else {
                        for (let m = 0; m < isdata.length; m++) {
                            if (
                                parseInt(subInfo.Price) ==
                                parseInt(isdata[m].new_exchange_price) &&
                                subInfo.barcode == isdata[m].barcode
                            ) {
                                or.cros = "rnewRow";
                                or.i = m;
                                break;
                            } else {
                                or.cros = "newRow";
                            }
                        }
                        await handRowAdd(or);

                        // await reCountCurr();
                        await handleCloseCuDWithSWState();
                        await handleClDia("fav", false);
                        await setSubInfo(insh.InfoSub);



                        setCurrUnit([]);
                    }
                }
                else {
                    for (let m = 0; m < isdata.length; m++) {
                        if (
                            parseInt(subInfo.Price) ==
                            parseInt(isdata[m].new_exchange_price) &&
                            subInfo.barcode == isdata[m].barcode
                        ) {
                            or.cros = "rnewRow";
                            or.i = m;
                            break;
                        } else {
                            or.cros = "newRow";
                        }
                    }

                    await handRowAdd(or);
                    await handleCloseCuDWithSWState();
                    await handleClDia("fav", false);
                    await setSubInfo(insh.InfoSub);

                    setCurrUnit([]);
                }
            } /* end Val1 */ else {
                alert("لا يمكنك التنزيل الكمية 0");
            }
        } /* end barcode */ else {
            alert("لا يوجد باركود للصنف تحقق من البيانات");
        }

    };

    const handNewInv = async () => {
        await handNewInvoice();
    };


    const handNewInvoice = async () => {
        setOpenPrint({ ...openPrint, open: false, localInv: {}, });
        setIsOpenItems(false);
        setIsOpenPay(false);
        setIshedden(false);
        setPdfToggle(null);
        reLoadLastInv();
        setIsData([]);
        setValueCustomers(AutoOptions.Customers[0]); //getAutoCustomers(0);
        setValueSalesmen(AutoOptions?.salesuser);
        setValueCostcenter(insh.Auto);
        setValueStock(AutoOptions.Stocks[0]); //getAutoStocks(0);
        setOmlaValue(getDefaultOmla(gets.omlats));
        setIsOpenPumps(AutoOptions?.permType?.id === 5 ? false : true);
        setIsOpenMain(AutoOptions?.permType?.id === 5 ? true : false);
        if (AutoOptions.Customers[0].Cust_inv_type != null) {
            if (AutoOptions.Customers[0]?.Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
                setValueType(AutoOptions.types[1]);
                setfromQountity({ ...fromQountity, pay: selectOilTypePay[0] });
                await changPaySwitch(selectOilTypePay[0].id, true);
            } else if (AutoOptions.Customers[0].Cust_inv_type == 1) {

                setfromQountity({ ...fromQountity, pay: selectOilTypePay[2] });
                setValueType(AutoOptions.types[1]);
                await changPaySwitch(selectOilTypePay[2].id, true);
            } else if (AutoOptions.Customers[0].Cust_inv_type == 3 || AutoOptions.Customers[0].Cust_inv_type == 4) {
                setfromQountity({ ...fromQountity, pay: selectOilTypePay[1] });
                setValueType(AutoOptions.types[1]);
                await changPaySwitch(selectOilTypePay[1].id, true);
            }
        } else {

            setfromQountity({ ...fromQountity, pay: selectOilTypePay[0] });
            setValueType(AutoOptions.types[1]);
            await changPaySwitch(selectOilTypePay[0].id, true);
        }

        setValueSafes(AutoOptions.Safes[0]);
        setSums(insh.Sums);
        setStor({ ...stor, comt: -1 });
        setExSub(0);
        setPayment(insh.Payment);
        setIsClick(insh.ished);
        setRemains(insh.Remains);
        setChecked({
            ...checked,
            costWithVat: true,
            discMinusck: false,
            discRateck: false,
            networkck: false,
            cashck: true,
            network_partck: false,
            cash_partck: false,
            agel_partck: false,
            bank_partck: false,
            emp_partck: false,
        });
        setOr(insh.Or);
        setIshed(insh.ished);
    };
    // func m t
    const befPushTos = async () => {
        addChangds();
    };

    let his = useHistory();

    const toPrint = async (type, e, hist) => {
        or.PrAC = hist;
        if (isdata.length == 0) {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف",
                time: 2000,
            });
        } else {
            await toWhere(type, e);
        }

    };


    const handPrint = async (procid,invs) => {
        const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
        const localInvoive = {
            proc_id: procid,
            invN: setting.titleHed,
            invNEn: setting.titleHedEn,
            salesman: valueSalesmen.name,
            backInv: "InvSO",
            branch: props.isDialog == false ? sto.branchi : props.invData.branch,
            ProcTypeInvProc: setting.PrTy_InPr,
            Delivery: permistionInv?.PRNTOUT,
            Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
            Direct: i18next.language == "ar" ? true : false,
            NRound: permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND,
            UseBefore: permistionInv?.USEBEFORE == null ? 1 : permistionInv?.USEBEFORE,
            branchInv: props.isDialog == false ? sto.branchi : props.invData.branch,
            salesmanName:"",
            invs:invs,
            post:0,
        }
        if (or.PrAC === 2 || or.PrAC === 1) {
            let invType = 1;
            if (or.PrAC === 2) {
                const num = Number(premiApp.billTemplate);
                if ([4, 8, 18, 23, 28, 29].includes(num)) {
                    invType = 4;
                } else if ([5, 9, 21, 22, 24, 25, 26, 27, 30].includes(num)) {
                    invType = 2;
                } else if ([6, 16, 19].includes(num)) {
                    invType = 3;
                } else if ([7, 2].includes(num)) {
                    invType = 5;
                } else if (num === 10) {
                    invType = 6;
                } else {
                    invType = 1;
                }
                setOpenPrint({ open: true, localInv: localInvoive, invType: invType, invKind: 2 });
            } else {
                const num = Number(premiApp.cashirTemplate);
                if ([2, 6].includes(num)) {
                    invType = 3;
                } else if ([4, 5, 7].includes(num)) {
                    invType = 2;
                } else { invType = 1; }
                setOpenPrint({ open: true, localInv: localInvoive, invType: invType, invKind: 1 });
            }
        } else {
        }
    };
    const [generating, setGenerating] = useState(false);

    const PushTos = async (t) => {
        befPushTos();
        let Sa_or_Pa_rest_id = null;
        console.log("the data is", remains);
        await ButtonLoading(t);

        const model = {
            inv: {
                ...idata,
                Pay_mouny: payment.paidup ? payment.paidup : 0,
                Remaining: payment.stay,
                agel_part: remains.agelPart,
                cash_part: remains.cashPart,
                network_part: remains.networkPart,
                bank_part: remains.bankPart,
                emp_part: remains.empPart,
                trans_no: maxShifts,
                center: AutoOptions?.centerUser?.id ?? -1,
                cust_id: valueCustomers.id,
                customer_name: valueCustomers.name,
                vat_type: or.postput==="toPut"?idata.vat_type:permiCuCo.CWVat?1:0,
            },
            // stor: stor,
            stor: {
                ...stor,
                Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
                isOrder: false,
                orderId: 0
            },

            parms: {
                omlaId: omlaValue?.id,
                tobaccoFees: premiA.tobaccoFees,
                omlaExchange: omlaValue?.exchange,
                iuserid: idata.create_user,
                iformidCuCo: dataF[3].id,
                proc_type: setting.routIS == "Inv_Sub_ToS/" ? 2 : 1,
                yashml: permiCuCo.yashml == "W",
                isAgel: remains?.isAgel,
                isCash: remains?.isCash,
                isNetwork: remains?.isNetwork,
                isBank: remains?.isBank,
                isEmp: remains?.isEmp,
                isWindow: remains?.isWindow,
                empId: remains?.empId,
                bankId: valueBanksPaid?.id,
                bankAcc: valueBanksPaid?.i,
                networkId: valueBankPMD?.id,
                networkAcc: valueBankPMD?.i,
                stockAcc: valueStock?.acc??0,
                acc_no: valueCustomers?.acc_no,
            },
            State: "Post",
            _Data: isdata,
        };

        if (or.postput == "toPost") {
            await axios
                .post(uri + "_HInv", model)
                .then((resI) => {
                    /*console.log('done I_po');*/
                    console.log(" the  data is", model);

                    if (or.PrAC !== 0) handPrint(resI.data.proc_id,resI.data);
                    ButtonSuccess(t, true);
                })
                .catch((resI) => {
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text:
                            "لم يتم اضافة الفاتورة" + "بسبب " + resI.response?.data?.Message,
                        time: 2000,
                    });

                    ButtonSuccess(t, false);
                });
        } else if (or.postput == "toPut") {
            await ButtonLoading(t);
            // I_Pu
            console.log(" the  data is", model);


            // if (permistionInv.IPU) {
            if (permistionInv.Up) {

                await axios
                    .put(uri + "_HInv", model)
                    .then((resI) => {
                        /*console.log('done I_po');*/
                        console.log(" the  data is", model);

                        if (or.PrAC !== 0) handPrint(resI.data.proc_id,resI.data);
                        ButtonSuccess(t, true);
                    })
                    .catch((resI) => {
                        handOSnack({
                            vertical: "top",
                            horizontal: "center",
                            severit: "warning",
                            text:
                                "لم يتم تعديل الفاتورة" +
                                "  " +
                                "بسبب " +
                                resI.response?.data?.Message,
                            time: 2000,
                        });
                        ButtonSuccess(t, false);
                    });
            } else {

                const tb = { inv: idata, stor: stor };

                await axios
                    .put(uri + "Inv_R_RS_", tb)
                    .then((resI_Pu) => {
                        /*console.log('done I_Pu');*/

                        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                            Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
                        else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;


                        if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id,resI_Pu.data);
                        ButtonSuccess(t, true);
                    })
                    .catch((resI_Pu) => {
                        ButtonSuccess(t, false); /*console.log('no I_Pu');*/
                    });
            }
        }
    };

    const PushTost = async (t) => {
        befPushTos();
        let Sa_or_Pa_rest_id = null;
        if (or.postput == "toPost") {
            await ButtonLoading(t);
            const tb = {
                invtemp: idata,
                stor: stor,
                parms: {
                    iuserid: idata.create_user,
                    iformidCuCo: dataF[3].id,
                },
            };

            await axios
                .post(uri + "Inv_R_RS__", tb)
                .then((resI) => {
                    /*console.log('done I_po');*/
                    axios
                        .post(
                            uri +
                            setting.routIS +
                            permiCuCo.yashml +
                            "?pcid=" +
                            resI.data.proc_id +
                            "&&State=Postt",
                            isdata
                        )
                        .then((resS) => {
                            /*console.log('done IS_po');*/
                            if (or.PrAC !== 0) handPrint(resI.data.proc_id,resI.data);
                            ButtonSuccess(t, true);
                        })
                        .catch((resS) => {
                            /*console.log('no IS_po');*/
                        });
                })
                .catch((resI) => {
                    ButtonSuccess(t, false);
                });
        }
        if (or.postput == "toPut") {
            await ButtonLoading("t");
            // I_Pu
            const tb = { inv: idata, stor: stor };

            await axios
                .put(uri + "Inv_R_RS", tb)
                .then((resI_Pu) => {
                    /*console.log('done I_Pu');*/

                    if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                        Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
                    else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;

                    // R_Pu
                    axios
                        .put(uri + "Restrictions" + "?pcid=" + resI_Pu.data.proc_id)
                        .then((retR_Pu) => {
                            /*console.log('done R_Pu');*/
                        })
                        .catch((retR_Pu) => {
                            /*console.log('no R_Pu');*/
                        });

                    // IS_De&Po
                    axios
                        .post(
                            uri +
                            setting.routIS +
                            permiCuCo.yashml +
                            "?pcid=" +
                            resI_Pu.data.proc_id +
                            "&&State=rePost",
                            isdata
                        )
                        .then((resIS_Po) => {
                            /*console.log('done resIS_Po');*/
                        })
                        .catch((resIS_Po) => {
                            /*console.log('no resIS_Po');*/
                        });

                    // RS_De&Po
                    axios
                        .post(uri + "Restrictions_Sub" + "?idR=" + Sa_or_Pa_rest_id, idata)
                        .then((resRS_Po) => {
                            /*console.log('done RS_Po');*/
                        })
                        .catch((resRS_Po) => {
                            /*console.log('no RS_Po');*/
                        });

                    /* E inner */
                    if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id,resI_Pu.data);
                    ButtonSuccess("t", true);
                })
                .catch((resI_Pu) => {
                    ButtonSuccess(t, false); /*console.log('no I_Pu');*/
                });
        }
    };

    const loadePayMents = () => {
        //  alert(idata.netAmount)
        setPayment({
            ...payment,
            paidupPMDcn: payment.paidup,
            stayPMDcn: payment.stay,
        });

        if (switchState.cashORnetworksw == false && valueType.id == 2) {
            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            setIData({
                ...idata,
                cash_part: idata.netAmount,
                network_part: "",
                agel_part: "",
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });
        } else if (switchState.cashORnetworksw == true && valueType.id == 2) {
            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            setIData({
                ...idata,
                cash_part: "",
                network_part: idata.netAmount,
                agel_part: "",
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });


            setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);
        }

        else if (valueType.id === 1) {

            if (payment.paidup > 0) {

                alert(payment.paidup)
                if (switchState.cashORnetworksw == false) {

                    setIData({
                        ...idata,
                        cash_part: payment.paidup,
                        network_part: "",
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                    });
                } else if (switchState.cashORnetworksw == true) {
                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: true,
                    });
                    setIData({
                        ...idata,
                        cash_part: "",
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: "",
                        bank_part: "",
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                    });
                    setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);

                }
            } else {
                setChecked({
                    ...checked,
                    cash_partck: false,
                    network_partck: false,
                    agel_partck: true,
                });
                setIData({
                    ...idata,
                    cash_part: payment.paidup,
                    network_part: "",
                    agel_part: payment.stay,
                    emp_part: "",
                    bank_part: "",
                    check_refno: "",
                    netAmountPMDcn: idata.netAmount,
                });
            }


        }


    };

    const usedPayedWindow = (v) => {
        if (v === 0) idata.used_payed_window = v;
        else idata.used_payed_window = v;
    };

    // ============================================ btn load
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const timer = React.useRef();

    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameSavetmp = clsx({
        [clasCAB.buttonSuccessCAB]: success.savetmp,
    });

    const buttonClassnameSavePMD = clsx({
        [clasCAB.buttonSuccessCAB]: success.savePMD,
    });

    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const buttonClassnamePrint = clsx({
        [clasCAB.buttonSuccessCAB]: success.print,
    });
    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const ButtonLoading = (prop) => {
        setLoading({ ...loading, [prop]: true });
    };
    const ButtonSuccess = (prop, state) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (
                prop == "delete" ||
                prop == "save" ||
                prop == "savetmp" ||
                prop == "savePMD"
            ) {
                if (state) handNewInv();
            }
            if (prop == "savePMD") {
                handClosePMD("done");
            }

            timer.current = window.setTimeout(() => {
                setSuccess({ ...success, [prop]: false });
            }, 500);
        }, 2000);
    };
    // ========================================== btn load


    const toDB = async (type, e) => {
        // if (checked.paymentDiloagck === true) {
        if (showPaid === true) {
            if (parseFloat(idata.netAmount) !== parseFloat(remains.allpart)) {
                alert("المبلغ غير متساوي");
            } else if (isdata.length == 0) {
                alert(" لا يوجد اصناف في الجدول ");
            } else if (parseFloat(idata.netAmount) == 0) {
                alert(" لا يمكن حفظ الفاتورة باجمالي صفر    ");
            }
            else {
                handClosePMD("cancle");
                await PushTos(type);
            }
        } else {

            usedPayedWindow(0);

            if (type == "savetmp") {
                await PushTost(type);
            } else {
                await PushTos(type);
            }
        }
    };

    const paidFun = (type) => {
        if (valueType.id == 2) {
            setRemains({
                ...remains,
                cashPart: switchState.cashORnetworksw == false ? idata.netAmount : 0,
                agelPart: 0,
                bankPart: 0,
                networkPart: switchState.cashORnetworksw == true ? idata.netAmount : 0,
                empPart: 0,
                isCash: switchState.cashORnetworksw == false,
                isWindow: true,
                isNetwork: switchState.cashORnetworksw == true,
                isAgel: false,
                isEmp: false,
                allpart: idata.netAmount,
                typePress: type,
            });
            // setValueBank(gets.Banks[0]); //getAutobanks(0);

        } else if (valueType.id == 1 && parseFloat(payment.paidup) > 0) {
            setRemains({
                ...remains,
                cashPart: switchState.cashORnetworksw == false ? payment.paidup : 0,
                agelPart: payment.stay,
                bankPart: 0,
                networkPart: switchState.cashORnetworksw == true ? payment.paidup : 0,
                empPart: 0,
                isCash: switchState.cashORnetworksw == false,
                isWindow: true,
                isAgel: true,
                isEmp: false,
                isNetwork: switchState.cashORnetworksw == true,
                allpart: idata.netAmount,
                typePress: type,
            });

        } else {
            setRemains({
                ...remains,
                cashPart: 0,
                agelPart: idata.netAmount,
                bankPart: 0,
                networkPart: 0,
                empPart: 0,
                isCash: false,
                isWindow: true,
                isAgel: true,
                isEmp: false,
                isNetwork: false,
                allpart: idata.netAmount,
                typePress: type,
            });
        }

        setValueBankPMD(switchState.cashORnetworksw ? valueBank : AutoOptions.Banks[0]);
        setValueEmployePMD(gets.Employees[0]);
        setPayment({ ...payment, paidupPMDcn: payment.paidup, stayPMDcn: payment?.stay });
    }


    const toWhere = (type, e) => {
        if (parseFloat(payment.paidup) > parseFloat(idata.netAmount)) {
            if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")) {
                if (switchState.cashORnetworksw == true) {
                    setValueType(AutoOptions.types[1]);

                    remains.networkPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.cashPart = 0;


                    idata.pay_type = 2;
                    idata.inv_type = 2;
                    idata.cash_part = 0;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = idata.netAmount;

                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: false,
                    });
                    blurPaid2(payment.paidup);

                }
                else {
                    setValueType(AutoOptions.types[1]);
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.networkPart = 0;


                    idata.pay_type = 1;
                    idata.inv_type = 2;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;

                    setChecked({
                        ...checked,
                        cash_partck: true,
                        network_partck: false,
                        agel_partck: false,
                    });
                    blurPaid2(payment.paidup);

                }
            }
            else {

                if (switchState.cashORnetworksw == true) {
                    setValueType(AutoOptions.types[1]);

                    remains.networkPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.cashPart = 0;
                    remains.empPart = 0;
                    payment.paidup = idata.netAmount;
                    payment.stay = 0;

                    idata.pay_type = 2;
                    idata.inv_type = 2;
                    idata.cash_part = 0;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = idata.netAmount;

                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: false,
                    });
                    if (isdata.length > 0) {
                        if (showPaid === true) {
                            // loadePayMents();
                            ///handleClickOpenPMD(TransitionRight);
                            // loadePayMents();
                            paidFun(type);
                            handleClickOpenPaid(type);

                        } else

                            toDB(type, e);
                    }
                    else {
                        // handOSnack({ vertical: 'top', horizontal: 'center' });
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: "يجب تنزيل اصناف",
                            time: 2000,
                        });
                    }


                }
                else {
                    setValueType(AutoOptions.types[1]);
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.networkPart = 0;


                    payment.paidup = idata.netAmount;
                    payment.stay = 0;
                    idata.pay_type = 1;
                    idata.inv_type = 2;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;

                    setChecked({
                        ...checked,
                        cash_partck: true,
                        network_partck: false,
                        agel_partck: false,
                    });
                    if (isdata.length > 0) {
                        if (checked.paymentDiloagck === true) {
                            loadePayMents();
                            handleClickOpenPMD(TransitionRight);
                        } else

                            toDB(type, e);
                    }
                    else {
                        // handOSnack({ vertical: 'top', horizontal: 'center' });
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: "يجب تنزيل اصناف",
                            time: 2000,
                        });
                    }


                }
            }

        }
        else {
            if (isdata.length > 0 && parseFloat(idata.netAmount) > 0) {
                if (showPaid === true) {
                    // loadePayMents();
                    paidFun(type);
                    handleClickOpenPaid(type);
                } else

                    toDB(type, e);
            } else if (isdata.length === 0) {
                // alert(" لا يوجد اصناف في الجدول ");
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يوجد اصناف في الجدول ... برجاء تنزيل الاصناف",
                    time: 2000,
                });
            } else if (parseFloat(idata.netAmount) === 0) {
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يمكن حفظ الفاتورة باجمالي صفر ...برجاء تعديل الاسعار",
                    time: 2000,
                });
            }
            else {
                // handOSnack({ vertical: 'top', horizontal: 'center' });
                handOSnack({
                    vertical: "top",
                    horizontal: "right",
                    severit: "warning",
                    text: "يجب تنزيل اصناف",
                    time: 2000,
                });
            }
        }
    };

    const hRowrAdd = (newData, resolve) => {
        let restaxvalrA = 0,
            resDiscPerA = 0,
            restotJustSumrA = 0,
            restotJustAfterDiscSumrA = 0,
            resDisCountrA = 0,
            resVal1SumrA = 0,
            resNetrA = 0,
            tot_befor_vat_after_disc = 0;

        resVal1SumrA = parseFloat(subInfo.val1) + parseFloat(isdata[or.i].val1);
        restotJustSumrA =
            parseFloat(isdata[or.i].new_exchange_price) * resVal1SumrA;
        resDisCountrA = (
            restotJustSumrA * parseFloat(subInfo.DiscPers / 100)
        ).toFixed(2);
        restotJustAfterDiscSumrA =
            parseFloat(restotJustSumrA) - parseFloat(resDisCountrA);

        restaxvalrA = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "taxval"
        );
        resNetrA = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "Net"
        );
        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );



        newData = {
            /* to show */
            minPrice: subInfo.minPrice,
            PricePu: subInfo.PricePu,
            unitame: subInfo.subInfo /*  - الـوحدة name */,
            symbol: subInfo.symbol /*  - إسم الصنف  */,

            /* to maaths */
            /* int - الإجمالي */
            totJust: restotJustSumrA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,


            tab3Val: subInfo?.is_tab3_curr == 1 ? restotJustAfterDiscSumrA : 0,
            /* to go */
            currency_from: parseInt(itemId) /* float - id الصنف */,
            unit: parseInt(subInfo.unit) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: resVal1SumrA,
            /* float - العبوة */
            val: parseFloat(subInfo.perc),
            sale_price: parseFloat(subInfo?.salePrice),

            /* float - الـسعر */
            new_exchange_price: parseFloat(isdata[or.i].new_exchange_price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountrA,
            /* float - %  خصم نسبة */

            DiscPers: subInfo.DiscPers,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(subInfo.taxperc),

            taxval: restaxvalrA,


            /* float - الصافي */
            netAmountSub: resNetrA,
            barcode: subInfo.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
        };

        //  alert(newData.netAmountSub)
        const isDataUpdate = [...isdata];
        const index = or.i;
        isDataUpdate[index] = newData;
        setExSub(isDataUpdate.length);
        handSums(isDataUpdate);

        setIsData([...isDataUpdate]);
    };

    const maths = (rTotAfterDic, taxperc, ty) => {
        if (permiCuCo.CWVat == 0 && taxperc != 0) {
            if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
            if (ty === "Net")
                return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
            if (ty === "before_vat") return rTotAfterDic.toFixed(2);
        } else if (permiCuCo.CWVat == 1 && taxperc != 0) {
            if (ty === "taxval")
                return (
                    parseFloat(rTotAfterDic) -
                    rTotAfterDic / (1 + taxperc / 100)
                ).toFixed(2);
            if (ty === "Net") return rTotAfterDic.toFixed(2);

            if (ty === "before_vat") return (rTotAfterDic - (rTotAfterDic / ((100 + taxperc) / taxperc))).toFixed(2);

        } else if (taxperc == 0) {
            if (ty === "taxval") return (0).toFixed(2);
            if (ty === "Net")
                return (rTotAfterDic).toFixed(2);
            if (ty === "before_vat") return rTotAfterDic.toFixed(2);
        }
    };

    const hRowAdd = (newData, resolve) => {
        setIsOpenItems(false);

        handleOpenPayScreen();
        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,
            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            tot_befor_vat_after_disc = 0;


        restotJustSumA = parseFloat(subInfo.totJust);
        restotJustAfterDiscSumA =
            parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);

        if (checked.discRateck === true) {
            //  alert('in if')
            resDiscPerA = parseFloat(invDisc.rate);
            resDisCountA = (
                parseFloat(invDisc.rate / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);

            restotJustAfterDiscSumA =
                parseFloat(subInfo.totJust) - parseFloat(resDisCountA);
        } else if (checked.discMinusck === true) {
            if (subInfo.totJust == 0) {
                resDiscPerA = (
                    (parseFloat(idata.minus) / 1) * 100).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * 1
                ).toFixed(2);
            } else {
                resDiscPerA = (
                    (parseFloat(idata.minus) / parseFloat(subInfo.totJust)) * 100).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(subInfo.totJust)
                ).toFixed(2);
            }

        }
        // disc sub level
        else {
            // alert('in else')
            resDiscPerA = parseFloat(subInfo.DiscPers);
            resDisCountA = (
                parseFloat(subInfo.DiscPers / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);
        }

        restaxvalA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "taxval"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );


        resNetA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "Net"
        );
        newData = {
            /* to show */
            minPrice: subInfo.minPrice,
            PricePu: subInfo.PricePu,
            unitame: valueItemUnits.subInfo /*  - الـوحدة name */,
            symbol: subInfo.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,



            tab3Val: subInfo?.is_tab3_curr == 1 ? restotJustAfterDiscSumA : 0,

            /* to go */
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */
            currency_from: parseInt(itemId) /* float - id الصنف */,
            unit: parseInt(subInfo.unit) /* int - الـوحدة id */,
            sale_price: parseFloat(subInfo?.salePrice),
            /* float - الكمية */
            val1: parseFloat(subInfo.val1),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(subInfo.perc),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(subInfo.Price),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            // new _discount: parseFloat(subInfo.discount),
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            // new _DiscPers: parseFloat(subInfo.DiscPers),
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(subInfo.taxperc),
            // new _taxperc: parseFloat(subInfo.taxperc),
            /* float - إجمالي قيمة المضافة  */
            // taxval: subInfo?.is_tab3_curr == 1 ? 2 * restaxvalA : restaxvalA,
            taxval: restaxvalA,

            /* float - الصافي */
            // netAmountSub: resNetA,

            netAmountSub: resNetA,


            // netAmo untSub: parseFloat(subInfo.totJust-subInfo.discount) + parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
            barcode: subInfo.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
        };
        if (errorList.length < 1) {
            //no error
            let dataToAdd = [...isdata];
            dataToAdd.push(newData);
            setIsData(dataToAdd);
            handSums(dataToAdd);
            setExSub(dataToAdd.length);
            setIsOpenItems(false);
            setIsOpenPay(true);

        } else {
            resolve();
        }

    };

    const [sums, setSums] = useState(insh.Sums);

    // الدفع المبقي
    const [payment, setPayment] = useState(insh.Payment);
    const [remains, setRemains] = useState(insh.Remains);
    const [isHedden, setIshedden] = useState(false);
    const [isClick, setIsClick] = useState(insh.ished);
    const [invDisc, setInvDisc] = useState(insh.InvDisc);


    const handSums = (data) => {
        let val1s = 0,
            tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
            netAmounts = 0,
            amountAfterDiscs = 0,
            amount_after_disc_before_vat = 0,
            discounts = 0,
            amountWithVats = 0,
            invTab3Val = 0,
            taxpercs;

        for (var m = 0; m < data.length; m++) {
            val1s += parseFloat(data[m].val1);
            tot_sale_or_purch += parseFloat(data[m].totJust);
            taxpercs = data[m].taxperc;
            /* جمالي القيمة المضافة */
            amountOfVats += parseFloat(data[m].taxval);
            netAmounts += parseFloat(data[m].netAmountSub);
            /* إجمالي قبل الضريبة */
            amountAfterDiscs += parseFloat(data[m].totAfterDisc);
            discounts += parseFloat(data[m].discount);

            // tobacco tax
            invTab3Val += parseFloat(data[m].tab3Val);
            amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
        }

        /* في الحالتين */
        /* إجمالي بعد الخصم */
        amountWithVats = (
            parseFloat(tot_sale_or_purch) - parseFloat(discounts)
        ).toFixed(2);
        /* يشمل */


        if (permiCuCo.CWVat == 1) {
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            amountOfVats = (
                parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountWithVats)
            ).toFixed(2);

        } else {
            /*لا يشمل */
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
            ).toFixed(2);

            amountWithVats = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
            ).toFixed(2);


        }



        setSums({ val1: val1s });
        setIData({
            ...idata,
            amountAfterDisc: amountAfterDiscs,
            amountWithVat: amountWithVats,
            tot_sale: tot_sale_or_purch,
            tot_purch: tot_sale_or_purch,
            netAmount: netAmounts,
            amountBefordisc: tot_sale_or_purch,
            amountOfVat: amountOfVats,
            minus: discounts,
            tab3Val: invTab3Val,
        });



        fcHandSumsToPayment(netAmounts);

        fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
    };

    const fcHandSumsToPayment = (newExPrice) => {
        // screan payment
        if (idata.inv_type == 1) {
            setPayment({ ...payment, stay: newExPrice, paidup: 0 });
            setRemains({ ...remains, cashPart: 0, agelPart: newExPrice, bankPart: 0, networkPart: 0 });
        }
        else {
            setPayment({ ...payment, paidup: newExPrice, stay: 0 });
            if (switchState.cashORnetworksw == false) {
                setRemains({ ...remains, cashPart: newExPrice, agelPart: 0, bankPart: 0, networkPart: 0 });
            } else if (switchState.cashORnetworksw == true) {
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: newExPrice });
            }
        }
    };

    const fcHandSumsToinvDisc = (totj, discs) => {
        // قيمة الخصم  مبلغ
        if (totj == 0 || totj == "") totj = 1;
        setInvDisc({
            minus: discs,
            rate: (parseFloat(parseFloat(discs) / totj) * 100).toFixed(2),
        });

    };

    const handRowAdd = (or) => {
        if (or.cros === "newRow") {
            hRowAdd();
        } else if (or.cros === "rnewRow") {
            if (permistionInv?.NOREP === true) {
                hRowAdd();
            } else {
                hRowrAdd();
            }

        }
        // }
    };



    const pinAutosValue = async (Tbl, id) => {
        if (Tbl === "Safe")
            AutoOptions.Safes.map((x) => {
                if (x.id == id) setValueSafes(x);
            });
        else if (Tbl === "Stock")
            AutoOptions.Stocks.map((x) => {
                if (x.id == id) setValueStock(x);
            });
        else if (Tbl === "omla")
            gets.omlats.map((x) => {
                if (x.id == id) setOmlaValue(x);
            });
        else if (Tbl === "Customer")
            optionsCustomers.map((x) => {
                if (x.id == id) setValueCustomers(x);
            });
        else if (Tbl === "salesmen")
            gets.salesmen.map((x) => {
                if (x.id == id) setValueSalesmen(x);
            });
        else if (Tbl === "costcenter")
            gets.costcenters.map((x) => {
                if (x.id == id) setValueCostcenter(x);
            });
        else if (Tbl === "Bank")
            AutoOptions.Banks.map((x) => {
                if (x.i == id) setValueBank(x);
            });
        else if (Tbl === "BankPMD")
            AutoOptions.Banks.map((x) => {
                if (x.id == id) setValueBankPMD(x);
            });
        else if (Tbl === "Bank2PMD")
            AutoOptions.Banks.map((x) => {
                if (x.id == id) setValueBankTransPMD(x);
            });
        else if (Tbl === "EmployeePMD")
            gets.Employees.map((x) => {
                if (x.id == id) setValueEmployePMD(x);
            });
        // }).catch(error => { })
    };

    const [numberbarcode, setNumberbarcode] = useState("");
    const [isBarcode, setIsBarcode] = useState(false);
    const [isApiConnect, setIsApiConnect] = useState(true);

    const [barcoding, setBarcoding] = useState(false);

    const [multiCodeList, setMultiCodeList] = useState([]);
    const SearchActivityReports = {
        barcode: '',
        curr: {},
        symbol: '',
        barcodeS: '',
        groupS: { id: -1, name: "الكل ", parentId: -1 },
        groupSe: { id: -1, name: "الكل ", parentId: -1 },
        group: { id: -1, name: "الكل", parentId: -1 },
        currS: {}

    };



    const [rptParams, setRptParams] = useState(SearchActivityReports);
    const valueBranch = AutoOptions.Branches.find((obj) => obj.id === sto.branchi);
    const [rptParamsSearch, setRptParamsSearch] = React.useState({...defualtValueSearch,
        user: AutoOptions?.Users[0], branch:valueBranch,
        selectTime:selectDateOrTime[0],
    });
    const [code, setCode] = useState([]);


    const [fetching, setFetching] = useState(false);



    const [groupsSubs, setGroupsSubs] = useState([]);
    const [symbolSearch, setSymbolSearch] = useState({});
    const [custData, setCustData] = useState({});



    const getCustomerData = async () => {
        if (valueCustomers?.id == null) {

            alert("ooooo");
        } else {
            await axios
                .get(
                    uri +
                    `RptSales/getCustData?custId=${valueCustomers?.id}`
                )
                .then((res) => {

                    setCustData(res.data?.custData[0]);
                })
                .catch((err) => {
                    toast.error("لا يوجد بيانات لهذا العميل ");
                    console.log(err);
                });

            if (custData != null) {
                handleOpenCustomerData();
            } else {
                toast.error("لا يوجد بيانات لهذا العميل ");
            }
        }
    };



    const showChosedInv = async (t, val) => {
        const tbs = {
            View_Inv_reseloving: true,
            parms: {
                iprocid: val,
                bol1: permiCuCo.CWVat,
                sProTyInvPro: setting.PrTy_InPr,
            },
            autos: {},
        };
        const alt = { View_Inv_reseloving: true };

        const al = Object.entries(alt).reduce((u, [n, v]) => {
            u[`${n}` + `${t ? "t" : ""}`] = v;
            return u;
        }, {});
        const alts = { ...al, ...tbs };
        await axios
            .post(uri + "Res", alts)
            .then((res) => {
                //console.log('res.data'); console.log(res.data);

                setIData(res.data.inv);
                console.log("the res data inve is", res.data.invS);
                // .then(resSub => {
                setIsData(res.data.invS);
                setItemName(res.data.invS[0]?.symbol);

                setPayment({
                    ...payment,
                    paidup: res.data.inv?.Pay_mouny,
                    stay: res.data.inv?.Remaining,
                });
                setIsOpenPumps(false);
                setIsOpenMain(false);
                setIsOpenItems(false);
                setIsOpenPay(true);
                setRemains({
                    ...remains,
                    cashPart: res.data.inv?.cash_part,
                    agelPart: res.data.inv?.agel_part,
                    networkPart: res.data.inv?.network_part,
                    bankPart: res.data.inv?.bank_part,
                    empPart: res.data.inv?.emp_part,
                });
                setSums({
                    ...sums,
                    val1: res.data.invS.reduce(
                        (totalVal1, sub) => totalVal1 + sub.val1,
                        0
                    ),
                });

                res.data.inv.inv_type === 1
                    ? setValueType(AutoOptions.types[0])
                    : setValueType(AutoOptions.types[1]);
                pinAutosValue("Safe", res.data.inv.safe);

                pinAutosValue("Stock", res.data.inv.stock);
                pinAutosValue("Customer", res.data.inv.cust_id);
                /* Autos options */
                if (res.data.inv.salesman != -1)
                    pinAutosValue("salesmen", res.data.inv.salesman);
                else {
                    setValueSalesmen(AutoOptions?.salesuser);
                }
                if (res.data.inv.center != -1)
                    pinAutosValue("costcenter", res.data.inv.center);
                else {
                    setValueCostcenter(insh.Auto);
                }
                let letNetworkck = false,
                    letCashck = false,
                    letcashORnetworksw = false;
                if (res.data.inv.pay_type === 1) {
                    setfromQountity({ ...fromQountity, pay: selectOilTypePay[1] });

                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type === 2) {
                    setfromQountity({ ...fromQountity, pay: selectOilTypePay[1] });

                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
                    setfromQountity({ ...fromQountity, pay: selectOilTypePay[2] });

                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
                    setfromQountity({ ...fromQountity, pay: selectOilTypePay[2] });

                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });

                    setValueBank(res.data.inv.bank);
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type === -1 && res.data.inv.Pay_mouny === 0) {
                    // setValueStock(AutoOptions.Stocks[0]);
                    setfromQountity({ ...fromQountity, pay: selectOilTypePay[2] });

                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }
                else {
                    // setValueStock(AutoOptions.Stocks[0]);
                    setfromQountity({ ...fromQountity, pay: selectOilTypePay[2] });

                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }

                setInfoInv({
                    id: res.data.inv.id,
                    InvId_Return:
                        res.data.inv.InvId_Return != null
                            ? res.data.inv.InvId_Return
                            : infoInv.InvId_Return,
                });

                /* ======= S in PMD ======= */
                /* checked AND Autos */
                let cash_p = false,
                    network_p = false,
                    agel_p = false,
                    bank_p = false,
                    emp_p = false;

                if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
                    cash_p = true;
                }

                if (
                    res.data.inv.network_part !== null ||
                    res.data.inv.network_part === 0
                ) {
                    // g etAutosOptions('Bank',res.data.inv.bank,'NWinPMD');
                    pinAutosValue("BankPMD", res.data.inv.bank);
                    network_p = true;
                } else {
                    setValueBankPMD(insh.AutoBank);
                }

                if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
                    agel_p = true;
                }

                if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
                    // g etAutosOptions('Bank',res.data.inv.bank,'Bk2inPMD');
                    pinAutosValue("Bank2PMD", res.data.inv.bank);
                    bank_p = true;
                }

                if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
                    // g etAutosOptions('Employee',res.data.inv.emp,'EmpinPMD');
                    pinAutosValue("EmployeePMD", res.data.inv.emp);
                    emp_p = true;
                }

                setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
                setChecked({
                    ...checked,

                    // in UP
                    cashck: letCashck,
                    networkck: letNetworkck,
                    // in PMD
                    cash_partck: cash_p,
                    network_partck: network_p,
                    agel_partck: agel_p,
                    bank_partck: bank_p,
                    emp_partck: emp_p,
                });

                /* ======= E in PMD ======= */
                // set discount values
                fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);
                handCloseDw();
            })
            .catch((error) => {
                /*console.log('no res');*/
            });
    };


    const [voucherDialog, setVoucherDialog] = useState({
        isOpen: false,
        data: "",
        onSucsess: "",
        onEnd: ""
    });


    const blurPaid2 = (pay) => {
        if (parseFloat(pay) > parseFloat(idata.netAmount)) {
            let valueVcher = (pay - parseFloat(idata.netAmount)).toFixed(2);
            //event.stopPropagation();
            setVoucherDialog({
                isOpen: true,
                data: {
                    ...idata, id: infoInv.id,
                    omlaId: omlaValue.id,
                    exchange: omlaValue.exchange,
                    valueOfVoucher: valueVcher
                },
                onSuccess: () => {
                    // toDiloa
                    setVoucherDialog({ ...voucherDialog, isOpen: false });
                    toDoIdata("notes", "Receipt voucher for the amount:" + valueVcher);
                },

            });
            payment.paidupPMDcn = parseFloat(idata.netAmount);
            payment.stayPMDcn = payment.stay;
            payment.paidup = idata.netAmount;
            payment.stay = 0;
            //setPayment({ ...payment, paidup: parseFloat(idata.netAmount), stay: 0 });
        }
    };

    /* s toggle btn */
    const [toggle, setToggle] = React.useState(null);
    const [pdfToggle, setPdfToggle] = React.useState(null);

    const [snack, setSnack] = React.useState(insh.Snack);

    const { vertical, horizontal, openSnak } = snack;

    const styBtn = {
        dis: { color: "#3b773d", background: "#4fa152" },
        undis: { color: "#fff" },
    };
    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };

    const handCSnack = (event, reason) => {
        // if (reason === 'clickaway') { return; }
        setSnack({ ...snack, openSnak: false });
    };

    const changChckedYahm = () =>
        alert("يمكنك تغييرها من إعدادات المبيعات في النظام");


    function ScrollTop(props) {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });

        const handUp = (event) => {
            const anchor = (event.target.ownerDocument || document).querySelector(
                "#back-to-top-anchor"
            );
            if (anchor) {
                anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        };

        return (
            <Zoom in={trigger}>
                <div onClick={handUp} role="presentation" className={clasFu.root}>
                    {children}
                </div>
            </Zoom>
        );
    }
    ScrollTop.propTypes = {
        children: PropTypes.element.isRequired,
        window: PropTypes.func,
    };

    const footAppbar = () => {
        return (
            <InvoiceOilAppBar {...{
                ...props,
                backHome,
                handOpenDw,
                isHedden,
                permistionInv,
                style,
                stElemnt,
                clasBA,
                switchState,
                handCOpenCu,
                TransitionUp,
                transForm,
                handOpenDwt,
                handNewInv,
                HomeBcode,
                TransitionDown,
                styBtn,
                isDialog,
                toWhere,
                loading,
                buttonClassnameSave,
                success,
                clasCAB,
                or,
                isOpenPay,
                clickOpenTogglePrint,
                buttonClassnamePrint,
                clickCloseToggle,
                toPrint,
                toggle
            }}
            />

        );
    };

    const frontInvs = () => {

        return (
            // <SearchInvoiceModal
            <SearchInvoicesMains
                {...{
                    openDw,
                    handCloseDw,
                    transition,
                    showChosedInv,
                    invsShow,
                    stElemnt,
                    style,
                    valueTypeFltr,
                    gets,
                    searchedInvShow,
                    setOr,
                    or,
                    optionsCustomers,
                    PcIdIvPc: setting.PrTy_InPr,
                    setting,
                    setIsClick,
                    ished,
                    AutoOptions,
                    isHedden,
                    permistionInv,
                    setIshedden,
                    isStock,
                    isMake,
                    isPurches,
                    invsSearchTable,
                    setInvsSearchTable,
                    setValue,
                    rptParamsSearch,
                    setRptParamsSearch
                }}
            />
        );
    };

    const [scroll, setScroll] = React.useState("paper");
    const clickOpenTogglePrint = (event) => {
        if (isdata.length !== 0) {
            setToggle(event.currentTarget);
        } else {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف أو إختيار فاتورة",
                time: 2000,
            });
        }
    };


    const clickCloseToggle = () => {
        setToggle(null);
    };

    const changinvDisc = (prop) => (event) => {
        console.log("the permissions is", permistionInv);

        let ret = null,
            evenTargetValue = null;
        if (isdata.length !== 0) {
            if (prop === "minus") {
                let value_dsc = Number(event.target.value);

                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
                    evenTargetValue = (
                        (value_dsc * 100) /
                        parseFloat(idata.tot_sale)
                    );
                else
                    evenTargetValue = (
                        (value_dsc * 100) /
                        parseFloat(idata.tot_purch)
                    );


                if (permistionInv.SDV !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(value_dsc),
                        permistionInv.SDV,
                        "DiscC"
                    );

                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");

                if (ret === "") {
                    event.target.value = "";
              /*invDisc.rate='';*/ afterInvDescount(0, value_dsc);
                } else {
                    afterInvDescount(evenTargetValue, value_dsc);
                }
            }
            else if (prop === "rate") {
                let value_perc = Number(event.target.value);

                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
                    evenTargetValue = (
                        parseFloat(idata.tot_sale) *
                        (value_perc / 100)
                    );
                else
                    evenTargetValue = (
                        parseFloat(idata.tot_purch) *
                        (value_perc / 100)
                    );

                if (permistionInv.SDP !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(value_perc),
                        permistionInv.SDP,
                        "DiscP"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
                if (ret === "") {
                    event.target.value = "";
              /*idata.minus='';*/ afterInvDescount(0, evenTargetValue);
                } else {
                    afterInvDescount(value_perc, evenTargetValue);
                }
            }
        }
        prop === "minus"
            ? setInvDisc({
                ...invDisc,
                [prop]: event.target.value,
                rate: parseFloat(evenTargetValue).toFixed(2),
            })
            : setInvDisc({
                ...invDisc,
                [prop]: event.target.value,
                minus: parseFloat(evenTargetValue).toFixed(2),
            });
    };

    const retPrmiSDPandSDV = (val, prmPandV, f) => {
        if (val > prmPandV && f === "DiscP") {
            alert(`
    قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
    قيمة الخصم الممنوحه: ${prmPandV}
    سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
          `);
            return "";
        } else if (val > prmPandV && f === "DiscC") {
            alert(`
    قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
    قيمة الخصم الممنوحه: ${prmPandV}
    سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
          `);
            return "";
        }
    };

    const afterInvDescount = (rate, desc_mount) => {
        const isdataU = [...isdata];
        if (rate === "") rate = 0;
        for (let m = 0; m < isdata.length; m++) {
            let percRate = Number(rate);
            isdataU[m].DiscPers = percRate.toFixed(5);
            isdataU[m].barcode = isdata[m].barcode;
            isdataU[m].currency_from = isdata[m].currency_from;
            isdataU[m].discountTotal = ((isdata[m].totJust * percRate) / 100);
            isdataU[m].discount = ((isdata[m].totJust * percRate) / 100).toFixed(5);
            isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
            isdataU[m].sub_branch = isdata[m].sub_branch;
            isdataU[m].sub_center = isdata[m].sub_center;
            isdataU[m].symbol = isdata[m].symbol;
            isdataU[m].totJust = isdata[m].totJust;

            isdataU[m].tot_before_vat_after_d =
                parseFloat(isdataU[m].totJust) - parseFloat(isdataU[m].discount);
            isdataU[m].taxperc = isdata[m].taxperc;

            /* from samer */
            isdataU[m].taxval = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "taxval"
            );
            isdataU[m].netAmountSub = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "Net"
            );
            isdataU[m].totAfterDisc = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "before_vat"
            );

            /* from me */
            // console.log("memememememmemmememmm");
            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].unit = isdata[m].unit;
            isdataU[m].unitame = isdata[m].unitame;
            isdataU[m].val = isdata[m].val;
            isdataU[m].val1 = isdata[m].val1;
            isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
        }

        SumAfterDesc(isdataU, desc_mount);
        setIsData([...isdataU]);
    };

    const SumAfterDesc = (data, desc_mount) => {
        let val1s = 0,
            tot_sale_or_purch = 0,
          /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
            netAmounts = 0,
            amountAfterDiscs = 0,
            amount_after_disc_before_vat = 0,
            discounts = 0,
            amountWithVats = 0,
            invTab3Val = 0,
            taxpercs;


        for (var m = 0; m < data.length; m++) {
            val1s += parseFloat(data[m].val1);
            tot_sale_or_purch += parseFloat(data[m].totJust);
            taxpercs = data[m].taxperc;
            /* جمالي القيمة المضافة */
            amountOfVats += parseFloat(data[m].taxval);
            netAmounts += parseFloat(data[m].netAmountSub);
            /* إجمالي قبل الضريبة */
            amountAfterDiscs += parseFloat(data[m].totAfterDisc);
            discounts += parseFloat(data[m].discount).toFixed(2);

            // tobacco tax
            invTab3Val += parseFloat(data[m].tab3Val);
            amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
        }

        /* في الحالتين */
        /* إجمالي بعد الخصم */
        amountWithVats = (
            parseFloat(tot_sale_or_purch) - parseFloat(desc_mount)
        ).toFixed(2);
        /* يشمل */


        if (permiCuCo.CWVat == 1) {
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            amountOfVats = (
                parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountWithVats)
            ).toFixed(2);

        } else {
            /*لا يشمل */
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
            ).toFixed(2);

            amountWithVats = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
            ).toFixed(2);


        }



        setSums({ val1: val1s });
        setIData({
            ...idata,
            amountAfterDisc: amountAfterDiscs,
            amountWithVat: amountWithVats,
            tot_sale: tot_sale_or_purch,
            tot_purch: tot_sale_or_purch,
            netAmount: netAmounts,
            amountBefordisc: tot_sale_or_purch,
            amountOfVat: amountOfVats,
            minus: desc_mount,
            tab3Val: invTab3Val,
        });



        fcHandSumsToPayment(netAmounts);

        fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
    };

    const changChcked = (event) => {
        if (
            event.target.name === "discMinusck" ||
            event.target.name === "discRateck"
        ) {
            RestAfterGetCurrMathRate();

            if (event.target.name === "discMinusck") {
                setChecked({
                    ...checked,
                    discMinusck: event.target.checked,
                    discRateck: false,
                });
                setUiElement({ ...uiElement, rate: true, minus: false });
            } else if (event.target.name === "discRateck") {
                setChecked({
                    ...checked,
                    discMinusck: false,
                    discRateck: event.target.checked,
                });
                setUiElement({ ...uiElement, rate: false, minus: true });
            }
        }

        if (event.target.name === "networkck" || event.target.name === "cashck") {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBankPMD(insh.AutoBankOp);

            if (event.target.name === "networkck") {
                setChecked({ ...checked, networkck: true, cashck: false });
                setUiElement({ ...uiElement, bank: false });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setValueBankPMD(AutoOptions.Banks[0]); //getAutobanksPMD(0);
            } else if (event.target.name === "cashck") {
                setChecked({ ...checked, networkck: false, cashck: true });
                setUiElement({ ...uiElement, bank: true });
                // setI_Data({...idata, pay_type:1 });
            }
        }

        /* ======== for payment Diloag ======== */
        if (event.target.name == "paymentDiloagck") {
            setChecked({ ...checked, paymentDiloagck: event.target.checked });
        } else if (event.target.name == "network_partck") {
            setChecked({
                ...checked,
                network_partck: event.target.checked,
                cash_partck: true,
            });
            if (event.target.checked === true) {
                setValueBankPMD(AutoOptions.Banks[0]);
            /*getAutobanksPMD(0);*/ changChckedPM("", "", "", "", "bankPM");
                chashVSnetwork(true);
                setUiElement({ ...uiElement, bankPM: false });
            } else if (event.target.checked === false) {
                MathChckedIdata("network_part", idata.network_part);
                changAutosPM("", "", "", "bankPM");
                chashVSnetwork(false);
                setUiElement({ ...uiElement, bankPM: true });
            }
        } else if (event.target.name === "agel_partck") {
            setChecked({
                ...checked,
                agel_partck: event.target.checked,
                cash_partck: true,
            });
            if (event.target.checked === false) {
                MathChckedIdata("agel_part", idata.agel_part);
            }
        } else if (event.target.name === "bank_partck") {
            setChecked({ ...checked, bank_partck: event.target.checked });
            if (event.target.checked === true) {
                setValueBankTransPMD(AutoOptions.Banks[0]);
            /*getAutobanks2PMD(0);*/ changChckedPM("", "", "", "", "bankPM2");
            } else if (event.target.checked === false) {
                MathChckedIdata("bank_part", idata.bank_part);
                changAutosPM("", "", "", "bankPM2");
            }
        } else if (event.target.name === "emp_partck") {
            setChecked({ ...checked, emp_partck: event.target.checked });
            if (event.target.checked === true) {
                setValueEmployePMD(gets.Employees[0]);
            /*getAutoEmployePMD(0);*/ changChckedPM("", "", "", "", "empPM");
            } else if (event.target.checked === false) {
                MathChckedIdata("emp_part", idata.emp_part);
                changAutosPM("", "", "", "empPM");
            }
        } else if (event.target.name === "autoOrStaticck") {
            setChecked({ ...checked, autoOrStaticck: event.target.checked });
        }
    }; // end checked

    const MathChckedIdata = (prop, val) => {
        let res = Number(val);
        res += idata.cash_part;
        setIData({ ...idata, [prop]: "", cash_part: res });
    };
    const RestAfterGetCurrMathRate = () => {
        setInvDisc(insh.InvDisc);
        afterGetCurrMathRate("");
    };
    const chashVSnetwork = async (valChecked) => {
        await changeNetorkCash(valChecked);
    };
    const changeNetorkCash = (valChecked) => {
        if (valChecked == true && valueType.id !== 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id, });
        } else if (valChecked == false && valueType.id !== 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true, stock: false });
            setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
        } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
        }
        else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
        }
    };
    const afterGetCurrMathRate = (rate) => {
        const isdataU = [...isdata];
        if (rate === "") rate = 0;
        for (let m = 0; m < isdata.length; m++) {
            isdataU[m].DiscPers = rate;
            isdataU[m].barcode = isdata[m].barcode;
            isdataU[m].currency_from = isdata[m].currency_from;
            isdataU[m].discount = ((isdata[m].totJust * rate) / 100).toFixed(2);
            isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
            isdataU[m].sub_branch = isdata[m].sub_branch;
            isdataU[m].sub_center = isdata[m].sub_center;
            isdataU[m].symbol = isdata[m].symbol;
            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].tot_before_vat_after_d =
                parseFloat(isdataU[m].totJust) - parseFloat(isdataU[m].discount);
            isdataU[m].taxperc = isdata[m].taxperc;

            /* from samer */
            isdataU[m].taxval = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "taxval"
            );
            isdataU[m].netAmountSub = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "Net"
            );
            isdataU[m].totAfterDisc = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "before_vat"
            );

            /* from me */
            // console.log("memememememmemmememmm");
            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].unit = isdata[m].unit;
            isdataU[m].unitame = isdata[m].unitame;
            isdataU[m].val = isdata[m].val;
            isdataU[m].val1 = isdata[m].val1;
            isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
        }

        handSums(isdataU);
        setIsData([...isdataU]);
    };

    const changAutoBankPMD = (newValue) => {
        setValueBankPMD(newValue);
        toDoIdata("bank2", newValue.id);
    };
    const changIdata = (prop) => (event) => {
        if (prop === "cashPart" && remains.isCash === true) {
            MathChangIdata(prop, event.target.value);
        } if (prop === "networkPart" && remains.isNetwork === true) {
            MathChangIdata(prop, event.target.value);
        } else if (prop === "agelPart" && remains.isAgel === true) {
            MathChangIdata(prop, event.target.value);
        } else if (prop === "bankPart" && remains.isBank === true) {
            MathChangIdata(prop, event.target.value);
        }
        else if (prop === "empPart" && remains.isEmp === true) {
            MathChangIdata(prop, event.target.value);
        }
        else if (prop == "check_refno" && remains.isBank == true) {
            toDoIdata(prop, event.target.value);
        } else if (prop == "refno") {
            toDoIdata(prop, event.target.value);
        } else if (prop == "date") {
            toDoIdata(prop, event.target.value);
        } else if (prop == "notes") {
            toDoIdata(prop, event.target.value);
        }
        else if (prop == "Due_date") {
            toDoIdata(prop, event.target.value);
        } else {
            toDoIdata(prop, event.target.value);
        }
    };
    const MathChangIdata = (prop, val) => {
        let ii = {
            totinv: Number(idata.netAmount),
            res: Number(val),
            sum: Number(0),
        };
        let i = {
            cashPart: Number(remains.cashPart),
            networkPart: Number(remains.networkPart),
            agelPart: Number(remains.agelPart),
            bankPart: Number(remains.bankPart),
            empPart: Number(remains.empPart),
        };
        let kind = "";
        const otherField = Object.keys(i).filter((f) => f !== prop);
        const remainaing = ii.totinv - ii.res;
        let newValue = { ...i, [prop]: ii.res };
        if (parseFloat(remainaing) < 0) {
            if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
                newValue[prop] = 0;
                otherField.forEach((f) => (newValue[f] = 0));
                newValue["agelPart"] = ii.totinv;
            } else {
                newValue[prop] = ii.totinv;
                otherField.forEach((f) => (newValue[f] = 0));
            }
        } else {
            newValue[prop] = ii.res;
            if (switchState.cashORnetworksw == false && remains.isCash == true &&
                remains.isAgel == false && prop !== "cashPart") {
                const cashFeild = Object.keys(i).filter((f) => f !== prop && f !== "cashPart");
                let sumOthers = cashFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                newValue["cashPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
            }
            else if (switchState.cashORnetworksw === true && remains.isNetwork == true
                && remains.isAgel == false && prop !== "networkPart") {
                const networkFeild = Object.keys(i).filter((f) => f !== prop && f !== "networkPart");
                let sumOthers = networkFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                newValue["networkPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
            } else if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
                const agelFeild = Object.keys(i).filter((f) => f !== prop && f !== "agelPart");
                let sumOthers = agelFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                if (ii.res >= ii.totinv) {
                    newValue[prop] = 0;
                    newValue["agelPart"] = ii.totinv.toFixed(2);
                } else {
                    newValue["agelPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
                }
            }
        }
        let all = parseFloat(newValue.cashPart) + parseFloat(newValue.agelPart) +
            parseFloat(newValue.bankPart) + parseFloat(newValue.empPart) + parseFloat(newValue.networkPart);
        if (prop === "bankPart" && (idata.bank2 == -1 || idata.bank2 == 0)) {
            idata.bank2 = AutoOptions.Banks[0].id;
        }else if (prop === "networkPart" && (idata.bank == -1 || idata.bank == 0)){
            idata.bank = AutoOptions.Banks[0].id;
        };

        let payMony=(parseFloat(newValue.bankPart)+parseFloat(newValue.cashPart)+parseFloat(newValue.networkPart)+
        parseFloat(newValue.empPart)).toFixed(2);
        let raimMony=(parseFloat(idata.netAmount)-parseFloat(payMony)).toFixed(2);
        setPayment({ ...payment, paidup: payMony??0, stay: raimMony??0 });
        if (parseFloat(newValue.agelPart)==0&& valueType.id===1)
            {idata.inv_type=2; setValueType(AutoOptions.types[1]);  }

        if (parseFloat(newValue.cashPart)===0 && idata.pay_type===1 && (parseFloat(newValue.networkPart)>0|| parseFloat(newValue.bankPart)>0)){
            idata.pay_type=2; uiElement.bank=false;  uiElement.stock=false; uiElement.payMethod=false;
            const text = transForm("network").toString();
            lbl.chashNetwork=text;
        }else if (parseFloat(newValue.cashPart)===parseFloat(idata.netAmount) &&  idata.pay_type!==1){
            idata.pay_type=1; idata.inv_type=2;  uiElement.bank=false;  uiElement.stock=false; uiElement.payMethod=false;
            const text = transForm("network").toString();
            lbl.chashNetwork=text;
        }else if(parseFloat(newValue.agelPart)>0 && idata.inv_type!==1&& idata.pay_type!==-1 ){
            idata.inv_type=1; idata.pay_type=-1; setValueType(AutoOptions.types[0]);
        }

        setRemains({
            ...remains,
            agelPart: newValue.agelPart,
            bankPart: newValue.bankPart,
            cashPart: newValue.cashPart,
            networkPart: newValue.networkPart,
            empPart: newValue.empPart,
            isCash: parseFloat(newValue.cashPart) > 0 ? true : false,
            isAgel: parseFloat(newValue.agelPart) > 0 ? true : false,
            isNetwork: parseFloat(newValue.networkPart) > 0 ? true : false,
            isBank: parseFloat(newValue.bankPart) > 0 ? true : false,
            isEmp: parseFloat(newValue.empPart) > 0 ? true : false,
            allpart: all,
        });
    };
    const changAutoEmployee = (newValue) => {
        setValueEmployePMD(newValue);
        toDoIdata("emp", newValue.id);
    };
    if (!isApiConnect) return <ReConnect />;
    return (
        <div className={classes.root}>

            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

                    <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <InvoiceOilHead
                                {...{
                                    AutoOptions,
                                    isPurches,
                                    changChckedYahm,
                                    checked,
                                    handleOpenCustomer,
                                    changAutoCustomers,
                                    optionsCustomers,
                                    changAutoType,
                                    valueType,
                                    infoInv,
                                    SaleCheckbox,
                                    valueCustomers,
                                    permiCuCo,
                                    getCustomerData,
                                    valueSafes,
                                    changAutoSafes,
                                    searchCustText,
                                    handleInputSearchCust,
                                    handleIconSearchCust,
                                    idata,
                                    changIdata,
                                    permistionInv
                                }}
                            />


                        </Container>

                        <br />
                        <Fragment>


                            {/* <Hidden smUp={["sm"]}> */}
                            {isOpenPumps && (
                                <PumpsCardList
                                    {...{
                                        // Pumps: AutoOptions?.PumpsInv,
                                        Pumps: AutoOptions?.PumpsInv.filter((obj) => obj.safe == valueSafes?.id),
                                        onPumpsClicks,
                                        isPurches,
                                        isStock,
                                    }}
                                />

                            )}
                            {isOpenMain && (
                                AutoOptions?.permType?.id === 5 ?
                                    (
                                        <OilItemsList
                                            {...{
                                                loading,
                                                cuRows: cuRows,
                                                AutoOptions,
                                                onRowClicks,
                                                isPurches,
                                                isStock,
                                            }}
                                        />
                                    ) :
                                    (
                                        <OilItemsList
                                            {...{
                                                loading,
                                                cuRows: valuePumps?.item == -1 ? cuRows :
                                                cuRows.filter((obj) => obj.id == valuePumps?.item) ?? cuRows,
                                                AutoOptions,
                                                onRowClicks,
                                                isPurches,
                                                isStock,
                                            }}
                                        />
                                    )
                            )}
                            {isOpenItems && (
                                <InvoiceOilItems
                                    {...{
                                        fromQountity,
                                        setfromQountity,
                                        selectOilType,
                                        subInfo,
                                        changInfo,
                                        getrowDataCurrencie,
                                        valuePumps,
                                        AutoOptions,
                                        idata,
                                        onChangeData
                                    }}
                                />

                            )}

                            {isOpenPay && (
                                <InvoiceOilPay
                                    {...{
                                        fromQountity,
                                        setfromQountity,
                                        selectOilTypePay,
                                        subInfo,
                                        changSwitch,
                                        valueStock,
                                        AutoOptions,
                                        changAutoStock,
                                        changAutoBank,
                                        toPrint,
                                        valueBank,
                                        itemName,
                                        loading,
                                        idata,
                                        valuePumps,
                                        showPaid,
                                        setShowPaid,
                                    }}

                                />

                            )}
                            {openPMD &&
                                <PaidWindowForm
                                    {... {
                                        idata,
                                        invDisc,
                                        remains,
                                        setRemains,
                                        payment,
                                        changPayment,
                                        buttonClassnameSavePMD,
                                        toDB,
                                        restPM,
                                        loading,
                                        handClosePMD,
                                        style,
                                        changClick,
                                        changinvDisc,
                                        gets,
                                        openPMD,
                                        valueEmployePMD,
                                        uiElement,
                                        changChcked,
                                        transition,
                                        checked,
                                        clasAo,
                                        valueBankPMD,
                                        changAutoBankPMD,
                                        changIdata,
                                        changAutoEmployee,
                                        valueBankTransPMD,
                                        changAutoBank2,
                                        typePress,
                                        valueType,
                                        AutoOptions,
                                        permistionInv
                                    }}
                                />}
                            {openPrint.open &&
                                <InvoiceTypePrintA4 isFocus={false} openPrint={openPrint} handNewInv={handNewInv} 
                                foundData={foundData} setFoundData={setFoundData}/>}
                            {frontInvs()}
                            {
                                allow.cud ? (
                                    <CustomerDialogData
                                        open={isOpenCustomerData}
                                        type={location.state.setting.cusType}
                                        onClose={() => {
                                            setIsOpenCustomerData(false);
                                        }}
                                        onSave={(updateData) => {
                                            setIsOpenCustomerData(false);
                                            reUpdateCust(updateData);
                                        }}
                                        custData={custData}
                                    />
                                ) : null}
                            {allow.c ? (
                                <CustomersDialog
                                    open={isOpenCustomer}
                                    type={location.state.setting.cusType}
                                    onClose={() => {
                                        setIsOpenCustomer(false);
                                    }}
                                    onSave={(custData) => {
                                        setIsOpenCustomer(false);
                                        reLoadCust(custData);
                                    }}

                                />
                            ) : null}
                        </Fragment>

                    </Grid>
                    {footAppbar()}
                </Grid>
            </Typography>
        </div>
    );


}
